import * as dt from "vue";
import { defineComponent as R, computed as p, openBlock as S, createElementBlock as _, normalizeClass as de, renderSlot as B, createElementVNode as T, createCommentVNode as Y, inject as Z, provide as te, createTextVNode as He, toDisplayString as ce, unref as V, shallowRef as kt, watch as ne, triggerRef as ct, onScopeDispose as dn, ref as k, onUnmounted as le, watchEffect as q, onMounted as j, cloneVNode as wt, h as N, Fragment as ue, reactive as Et, nextTick as me, toRaw as ve, getCurrentInstance as cn, Teleport as St, createBlock as Se, withCtx as Q, createVNode as oe, onBeforeUnmount as pn, Transition as Tt, renderList as ze, resolveDynamicComponent as fn } from "vue";
const vn = ["disabled"], mn = /* @__PURE__ */ R({
  __name: "TEButton",
  props: {
    primary: { type: Boolean },
    disabled: { type: Boolean },
    color: {}
  },
  setup(e) {
    const n = e, t = {
      zinc: "bg-zinc-500 dark:bg-zinc-800 hover:bg-zinc-600 focus:bg-zinc-600 hover:bg-zinc-600 focus:bg-zinc-600 active:bg-zinc-700 hover:dark:bg-zinc-700",
      red: "bg-red-500 dark:bg-red-800 hover:bg-red-600 focus:bg-red-600 hover:bg-red-600 focus:bg-red-600 active:bg-red-700 hover:dark:bg-red-700",
      orange: "bg-orange-500 dark:bg-orange-800 hover:bg-orange-600 focus:bg-orange-600 hover:bg-orange-600 focus:bg-orange-600 active:bg-orange-700 hover:dark:bg-orange-700",
      yellow: "bg-yellow-500 dark:bg-yellow-800 hover:bg-yellow-600 focus:bg-yellow-600 hover:bg-yellow-600 focus:bg-yellow-600 active:bg-yellow-700 hover:dark:bg-yellow-700",
      green: "bg-green-500 dark:bg-green-800 hover:bg-green-600 focus:bg-green-600 hover:bg-green-600 focus:bg-green-600 active:bg-green-700 hover:dark:bg-green-700",
      teal: "bg-teal-500 dark:bg-teal-800 hover:bg-teal-600 focus:bg-teal-600 hover:bg-teal-600 focus:bg-teal-600 active:bg-teal-700 hover:dark:bg-teal-700",
      blue: "bg-blue-500 dark:bg-blue-800 hover:bg-blue-600 focus:bg-blue-600 hover:bg-blue-600 focus:bg-blue-600 active:bg-blue-700 hover:dark:bg-blue-700",
      sky: "bg-sky-500 dark:bg-sky-800 hover:bg-sky-600 focus:bg-sky-600 hover:bg-sky-600 focus:bg-sky-600 active:bg-sky-700 hover:dark:bg-sky-700",
      indigo: "bg-indigo-500 dark:bg-indigo-800 hover:bg-indigo-600 focus:bg-indigo-600 hover:bg-indigo-600 focus:bg-indigo-600 active:bg-indigo-700 hover:dark:bg-indigo-700",
      purple: "bg-purple-500 dark:bg-purple-800 hover:bg-purple-600 focus:bg-purple-600 hover:bg-purple-600 focus:bg-purple-600 active:bg-purple-700 hover:dark:bg-purple-700",
      pink: "bg-pink-500 dark:bg-pink-800 hover:bg-pink-600 focus:bg-pink-600 hover:bg-pink-600 focus:bg-pink-600 active:bg-pink-700 hover:dark:bg-pink-700",
      primary: "bg-primary-500 dark:bg-primary-800 hover:bg-primary-600 focus:bg-primary-600 hover:bg-primary-600 focus:bg-primary-600 active:bg-primary-700 hover:dark:bg-primary-700",
      accent: "bg-accent-500 dark:bg-accent-800 hover:bg-accent-600 focus:bg-accent-600 hover:bg-accent-600 focus:bg-accent-600 active:bg-accent-700 hover:dark:bg-accent-700",
      rose: "bg-rose-500 dark:bg-rose-800 hover:bg-rose-600 focus:bg-rose-600 hover:bg-rose-600 focus:bg-rose-600 active:bg-rose-700 hover:dark:bg-rose-700",
      emerald: "bg-emerald-500 dark:bg-emerald-800 hover:bg-emerald-600 focus:bg-emerald-600 hover:bg-emerald-600 focus:bg-emerald-600 active:bg-emerald-700 hover:dark:bg-emerald-700"
    }, l = {
      zinc: "bg-zinc-100 dark:bg-zinc-950 dark:text-zinc-400  text-zinc-600 hover:bg-zinc-200 focus:ring-2 ring-zinc-600 dark:zing-zinc-400 hover:dark:bg-zinc-700",
      red: "bg-red-100 dark:bg-red-950 dark:text-red-400  text-red-600 hover:bg-red-200 focus:ring-2 ring-red-600 dark:zing-red-400 hover:dark:bg-red-700",
      orange: "bg-orange-100 dark:bg-orange-950 dark:text-orange-400  text-orange-600 hover:bg-orange-200 focus:ring-2 ring-orange-600 dark:zing-orange-400 hover:dark:bg-orange-700",
      yellow: "bg-yellow-100 dark:bg-yellow-950 dark:text-yellow-400  text-yellow-600 hover:bg-yellow-200 focus:ring-2 ring-yellow-600 dark:zing-yellow-400 hover:dark:bg-yellow-700",
      green: "bg-green-100 dark:bg-green-950 dark:text-green-400  text-green-600 hover:bg-green-200 focus:ring-2 ring-green-600 dark:zing-green-400 hover:dark:bg-green-700",
      teal: "bg-teal-100 dark:bg-teal-950 dark:text-teal-400  text-teal-600 hover:bg-teal-200 focus:ring-2 ring-teal-600 dark:zing-teal-400 hover:dark:bg-teal-700",
      blue: "bg-blue-100 dark:bg-blue-950 dark:text-blue-400  text-blue-600 hover:bg-blue-200 focus:ring-2 ring-blue-600 dark:zing-blue-400 hover:dark:bg-blue-700",
      sky: "bg-sky-100 dark:bg-sky-950 dark:text-sky-400  text-sky-600 hover:bg-sky-200 focus:ring-2 ring-sky-600 dark:zing-sky-400 hover:dark:bg-sky-700",
      indigo: "bg-indigo-100 dark:bg-indigo-950 dark:text-indigo-400  text-indigo-600 hover:bg-indigo-200 focus:ring-2 ring-indigo-600 dark:zing-indigo-400 hover:dark:bg-indigo-700",
      purple: "bg-purple-100 dark:bg-purple-950 dark:text-purple-400  text-purple-600 hover:bg-purple-200 focus:ring-2 ring-purple-600 dark:zing-purple-400 hover:dark:bg-purple-700",
      pink: "bg-pink-100 dark:bg-pink-950 dark:text-pink-400  text-pink-600 hover:bg-pink-200 focus:ring-2 ring-pink-600 dark:zing-pink-400 hover:dark:bg-pink-700",
      primary: "bg-primary-100 dark:bg-primary-950 dark:text-primary-400  text-primary-600 hover:bg-primary-200 focus:ring-2 ring-primary-600 dark:zing-primary-400 hover:dark:bg-primary-700",
      accent: "bg-accent-100 dark:bg-accent-950 dark:text-accent-400  text-accent-600 hover:bg-accent-200 focus:ring-2 ring-accent-600 dark:zing-accent-400 hover:dark:bg-accent-700",
      rose: "bg-rose-100 dark:bg-rose-950 dark:text-rose-400  text-rose-600 hover:bg-rose-200 focus:ring-2 ring-rose-600 dark:zing-rose-400 hover:dark:bg-rose-700",
      emerald: "bg-emerald-100 dark:bg-emerald-950 dark:text-emerald-400  text-emerald-600 hover:bg-emerald-200 focus:ring-2 ring-emerald-600 dark:zing-emerald-400 hover:dark:bg-emerald-700"
    }, o = p(() => n.primary ? `${t[n.color ?? "primary"]} text-white` : l[n.color ?? "primary"]);
    return (a, i) => (S(), _("button", {
      type: "button",
      disabled: n.disabled,
      class: de([
        n.disabled ? `cursor-not-allowed ${n.primary ? "bg-gray-500" : "bg-gray-300 dark:bg-gray-600"} text-${n.color ?? "primary"}-900` : o.value,
        "inline-block rounded-md px-2.5 py-1.5 min-w-16 text-sm font-semibold active:scale-95 active:opacity-85 leading-normal shadow-sm transition duration-150 ease-in-out focus:outline-none focus:ring-0"
      ])
    }, [
      B(a.$slots, "default")
    ], 10, vn));
  }
}), Le = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [l, o] of n)
    t[l] = o;
  return t;
}, gn = {}, hn = { class: "flex w-full justify-center" }, bn = { class: "max-w-8xl w-full rounded-lg bg-white p-4 shadow dark:border-primary-400 dark:text-zinc-100 dark:bg-zinc-800" }, yn = {
  key: 0,
  class: "-mx-4 -mb-4 mt-5 border-t-2 bg-gray-50 px-4 pb-4 dark:border-zinc-700 dark:bg-zinc-900 rounded-b-lg"
}, xn = { class: "flex justify-end pt-4" };
function kn(e, n) {
  return S(), _("div", hn, [
    T("div", bn, [
      B(e.$slots, "default"),
      e.$slots.actions ? (S(), _("div", yn, [
        T("div", xn, [
          B(e.$slots, "actions")
        ])
      ])) : Y("", !0)
    ])
  ]);
}
const wn = /* @__PURE__ */ Le(gn, [["render", kn]]), En = ["id", "value", "type", "placeholder", "autofocus", "autocomplete"], Sn = /* @__PURE__ */ R({
  __name: "TETextInput",
  props: {
    name: {},
    placeholder: {},
    required: { type: Boolean },
    type: {},
    modelValue: {},
    error: { type: Boolean },
    autocomplete: {},
    autofocus: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, l = n;
    function o(r) {
      const s = r.target;
      l("update:modelValue", s.value);
    }
    const a = p(() => Z(
      // @ts-expect-error its not too complex
      `error-${t.name}`,
      p(() => {
      })
    )), i = p(() => {
      var r;
      return (r = a.value) != null && r.value ? "border-red-500" : "border-gray-400";
    });
    return (r, s) => (S(), _("input", {
      id: r.name,
      value: r.modelValue,
      type: r.type ?? "text",
      placeholder: r.placeholder,
      class: de(["block w-full rounded-md border-0 px-2 py-1.5 text-gray-900 outline-0 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:outline-0 focus:ring-2 focus:ring-inset focus:ring-primary-600 focus:transition-all sm:text-sm sm:leading-6 dark:bg-zinc-600 dark:text-white dark:ring-zinc-900 focus:dark:ring-primary-900", i.value]),
      autofocus: r.autofocus,
      autocomplete: r.autocomplete,
      onInput: o
    }, null, 42, En));
  }
}), Tn = { class: "py-2" }, $n = ["for"], On = {
  key: 0,
  class: "text-red-500"
}, _n = { class: "" }, Cn = {
  key: 0,
  class: "text-sm text-red-600"
}, In = /* @__PURE__ */ R({
  __name: "TETopLabelLayout",
  props: {
    title: {},
    required: { type: Boolean },
    name: {},
    error: {}
  },
  setup(e) {
    const n = e, t = p(() => n.error ?? void 0);
    return te(
      `error-${n.name}`,
      p(() => t.value ?? void 0)
    ), (l, o) => (S(), _("div", Tn, [
      T("label", {
        for: l.name,
        class: "block text-sm font-medium leading-6 text-gray-900 dark:text-gray-300"
      }, [
        He(ce(l.title), 1),
        l.required ? (S(), _("span", On, "*")) : Y("", !0)
      ], 8, $n),
      T("div", _n, [
        B(l.$slots, "default", { class: "block w-full" })
      ]),
      t.value ? (S(), _("div", Cn, ce(t.value), 1)) : Y("", !0)
    ]));
  }
});
function $e(e, n, t) {
  let l = t.initialDeps ?? [], o;
  return () => {
    var a, i, r, s;
    let u;
    t.key && ((a = t.debug) != null && a.call(t)) && (u = Date.now());
    const d = e();
    if (!(d.length !== l.length || d.some((b, h) => l[h] !== b)))
      return o;
    l = d;
    let f;
    if (t.key && ((i = t.debug) != null && i.call(t)) && (f = Date.now()), o = n(...d), t.key && ((r = t.debug) != null && r.call(t))) {
      const b = Math.round((Date.now() - u) * 100) / 100, h = Math.round((Date.now() - f) * 100) / 100, w = h / 16, C = (P, m) => {
        for (P = String(P); P.length < m; )
          P = " " + P;
        return P;
      };
      console.info(
        `%c⏱ ${C(h, 5)} /${C(b, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * w, 120)
        )}deg 100% 31%);`,
        t == null ? void 0 : t.key
      );
    }
    return (s = t == null ? void 0 : t.onChange) == null || s.call(t, o), o;
  };
}
function qe(e, n) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const Rn = (e, n) => Math.abs(e - n) < 1, zn = (e, n, t) => {
  let l;
  return function(...o) {
    e.clearTimeout(l), l = e.setTimeout(() => n.apply(this, o), t);
  };
}, Pn = (e) => e, Ln = (e) => {
  const n = Math.max(e.startIndex - e.overscan, 0), t = Math.min(e.endIndex + e.overscan, e.count - 1), l = [];
  for (let o = n; o <= t; o++)
    l.push(o);
  return l;
}, Dn = (e, n) => {
  const t = e.scrollElement;
  if (!t)
    return;
  const l = e.targetWindow;
  if (!l)
    return;
  const o = (i) => {
    const { width: r, height: s } = i;
    n({ width: Math.round(r), height: Math.round(s) });
  };
  if (o(t.getBoundingClientRect()), !l.ResizeObserver)
    return () => {
    };
  const a = new l.ResizeObserver((i) => {
    const r = i[0];
    if (r != null && r.borderBoxSize) {
      const s = r.borderBoxSize[0];
      if (s) {
        o({ width: s.inlineSize, height: s.blockSize });
        return;
      }
    }
    o(t.getBoundingClientRect());
  });
  return a.observe(t, { box: "border-box" }), () => {
    a.unobserve(t);
  };
}, pt = {
  passive: !0
}, Fn = typeof window > "u" ? !0 : "onscrollend" in window, Mn = (e, n) => {
  const t = e.scrollElement;
  if (!t)
    return;
  const l = e.targetWindow;
  if (!l)
    return;
  let o = 0;
  const a = Fn ? () => {
  } : zn(
    l,
    () => {
      n(o, !1);
    },
    e.options.isScrollingResetDelay
  ), i = (u) => () => {
    const { horizontal: d, isRtl: c } = e.options;
    o = d ? t.scrollLeft * (c && -1 || 1) : t.scrollTop, a(), n(o, u);
  }, r = i(!0), s = i(!1);
  return s(), t.addEventListener("scroll", r, pt), t.addEventListener("scrollend", s, pt), () => {
    t.removeEventListener("scroll", r), t.removeEventListener("scrollend", s);
  };
}, An = (e, n, t) => {
  if (n != null && n.borderBoxSize) {
    const l = n.borderBoxSize[0];
    if (l)
      return Math.round(
        l[t.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    e.getBoundingClientRect()[t.options.horizontal ? "width" : "height"]
  );
}, Nn = (e, {
  adjustments: n = 0,
  behavior: t
}, l) => {
  var o, a;
  const i = e + n;
  (a = (o = l.scrollElement) == null ? void 0 : o.scrollTo) == null || a.call(o, {
    [l.options.horizontal ? "left" : "top"]: i,
    behavior: t
  });
};
class Bn {
  constructor(n) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let t = null;
      const l = () => t || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : t = new this.targetWindow.ResizeObserver((o) => {
        o.forEach((a) => {
          this._measureElement(a.target, a);
        });
      }));
      return {
        disconnect: () => {
          var o;
          (o = l()) == null || o.disconnect(), t = null;
        },
        observe: (o) => {
          var a;
          return (a = l()) == null ? void 0 : a.observe(o, { box: "border-box" });
        },
        unobserve: (o) => {
          var a;
          return (a = l()) == null ? void 0 : a.unobserve(o);
        }
      };
    })(), this.range = null, this.setOptions = (t) => {
      Object.entries(t).forEach(([l, o]) => {
        typeof o > "u" && delete t[l];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: Pn,
        rangeExtractor: Ln,
        onChange: () => {
        },
        measureElement: An,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        ...t
      };
    }, this.notify = (t) => {
      var l, o;
      (o = (l = this.options).onChange) == null || o.call(l, this, t);
    }, this.maybeNotify = $e(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (t) => {
        this.notify(t);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((t) => t()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var t;
      const l = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== l) {
        if (this.cleanup(), !l) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = l, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((t = this.scrollElement) == null ? void 0 : t.window) ?? null, this.elementsCache.forEach((o) => {
          this.observer.observe(o);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (o) => {
            this.scrollRect = o, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (o, a) => {
            this.scrollAdjustments = 0, this.scrollDirection = a ? this.getScrollOffset() < o ? "forward" : "backward" : null, this.scrollOffset = o, this.isScrolling = a, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (t, l) => {
      const o = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
      for (let i = l - 1; i >= 0; i--) {
        const r = t[i];
        if (o.has(r.lane))
          continue;
        const s = a.get(
          r.lane
        );
        if (s == null || r.end > s.end ? a.set(r.lane, r) : r.end < s.end && o.set(r.lane, !0), o.size === this.options.lanes)
          break;
      }
      return a.size === this.options.lanes ? Array.from(a.values()).sort((i, r) => i.end === r.end ? i.index - r.index : i.end - r.end)[0] : void 0;
    }, this.getMeasurementOptions = $e(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (t, l, o, a, i) => (this.pendingMeasuredCacheIndexes = [], {
        count: t,
        paddingStart: l,
        scrollMargin: o,
        getItemKey: a,
        enabled: i
      }),
      {
        key: !1
      }
    ), this.getMeasurements = $e(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: t, paddingStart: l, scrollMargin: o, getItemKey: a, enabled: i }, r) => {
        if (!i)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((d) => {
          this.itemSizeCache.set(d.key, d.size);
        }));
        const s = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const u = this.measurementsCache.slice(0, s);
        for (let d = s; d < t; d++) {
          const c = a(d), f = this.options.lanes === 1 ? u[d - 1] : this.getFurthestMeasurement(u, d), b = f ? f.end + this.options.gap : l + o, h = r.get(c), w = typeof h == "number" ? h : this.options.estimateSize(d), C = b + w, P = f ? f.lane : d % this.options.lanes;
          u[d] = {
            index: d,
            start: b,
            size: w,
            end: C,
            key: c,
            lane: P
          };
        }
        return this.measurementsCache = u, u;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = $e(
      () => [this.getMeasurements(), this.getSize(), this.getScrollOffset()],
      (t, l, o) => this.range = t.length > 0 && l > 0 ? Vn({
        measurements: t,
        outerSize: l,
        scrollOffset: o
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getIndexes = $e(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (t, l, o, a) => l === null ? [] : t({
        startIndex: l.startIndex,
        endIndex: l.endIndex,
        overscan: o,
        count: a
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (t) => {
      const l = this.options.indexAttribute, o = t.getAttribute(l);
      return o ? parseInt(o, 10) : (console.warn(
        `Missing attribute name '${l}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (t, l) => {
      const o = this.indexFromElement(t), a = this.measurementsCache[o];
      if (!a)
        return;
      const i = a.key, r = this.elementsCache.get(i);
      r !== t && (r && this.observer.unobserve(r), this.observer.observe(t), this.elementsCache.set(i, t)), t.isConnected && this.resizeItem(o, this.options.measureElement(t, l, this));
    }, this.resizeItem = (t, l) => {
      const o = this.measurementsCache[t];
      if (!o)
        return;
      const a = this.itemSizeCache.get(o.key) ?? o.size, i = l - a;
      i !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(o, i, this) : o.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", i), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += i,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(o.index), this.itemSizeCache = new Map(this.itemSizeCache.set(o.key, l)), this.notify(!1));
    }, this.measureElement = (t) => {
      if (!t) {
        this.elementsCache.forEach((l, o) => {
          l.isConnected || (this.observer.unobserve(l), this.elementsCache.delete(o));
        });
        return;
      }
      this._measureElement(t, void 0);
    }, this.getVirtualItems = $e(
      () => [this.getIndexes(), this.getMeasurements()],
      (t, l) => {
        const o = [];
        for (let a = 0, i = t.length; a < i; a++) {
          const r = t[a], s = l[r];
          o.push(s);
        }
        return o;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (t) => {
      const l = this.getMeasurements();
      if (l.length !== 0)
        return qe(
          l[$t(
            0,
            l.length - 1,
            (o) => qe(l[o]).start,
            t
          )]
        );
    }, this.getOffsetForAlignment = (t, l) => {
      const o = this.getSize(), a = this.getScrollOffset();
      l === "auto" && (t <= a ? l = "start" : t >= a + o ? l = "end" : l = "start"), l === "start" ? t = t : l === "end" ? t = t - o : l === "center" && (t = t - o / 2);
      const i = this.options.horizontal ? "scrollWidth" : "scrollHeight", s = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[i] : this.scrollElement[i] : 0) - o;
      return Math.max(Math.min(s, t), 0);
    }, this.getOffsetForIndex = (t, l = "auto") => {
      t = Math.max(0, Math.min(t, this.options.count - 1));
      const o = this.measurementsCache[t];
      if (!o)
        return;
      const a = this.getSize(), i = this.getScrollOffset();
      if (l === "auto")
        if (o.end >= i + a - this.options.scrollPaddingEnd)
          l = "end";
        else if (o.start <= i + this.options.scrollPaddingStart)
          l = "start";
        else
          return [i, l];
      const r = l === "end" ? o.end + this.options.scrollPaddingEnd : o.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(r, l), l];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (t, { align: l = "start", behavior: o } = {}) => {
      this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(t, l), {
        adjustments: void 0,
        behavior: o
      });
    }, this.scrollToIndex = (t, { align: l = "auto", behavior: o } = {}) => {
      t = Math.max(0, Math.min(t, this.options.count - 1)), this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const a = this.getOffsetForIndex(t, l);
      if (!a) return;
      const [i, r] = a;
      this._scrollToOffset(i, { adjustments: void 0, behavior: o }), o !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(t)
        )) {
          const [u] = qe(
            this.getOffsetForIndex(t, r)
          );
          Rn(u, this.getScrollOffset()) || this.scrollToIndex(t, { align: r, behavior: o });
        } else
          this.scrollToIndex(t, { align: r, behavior: o });
      }));
    }, this.scrollBy = (t, { behavior: l } = {}) => {
      this.cancelScrollToIndex(), l === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + t, {
        adjustments: void 0,
        behavior: l
      });
    }, this.getTotalSize = () => {
      var t;
      const l = this.getMeasurements();
      let o;
      return l.length === 0 ? o = this.options.paddingStart : o = this.options.lanes === 1 ? ((t = l[l.length - 1]) == null ? void 0 : t.end) ?? 0 : Math.max(
        ...l.slice(-this.options.lanes).map((a) => a.end)
      ), Math.max(
        o - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (t, {
      adjustments: l,
      behavior: o
    }) => {
      this.options.scrollToFn(t, { behavior: o, adjustments: l }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(n);
  }
}
const $t = (e, n, t, l) => {
  for (; e <= n; ) {
    const o = (e + n) / 2 | 0, a = t(o);
    if (a < l)
      e = o + 1;
    else if (a > l)
      n = o - 1;
    else
      return o;
  }
  return e > 0 ? e - 1 : 0;
};
function Vn({
  measurements: e,
  outerSize: n,
  scrollOffset: t
}) {
  const l = e.length - 1, a = $t(0, l, (r) => e[r].start, t);
  let i = a;
  for (; i < l && e[i].end < t + n; )
    i++;
  return { startIndex: a, endIndex: i };
}
function jn(e) {
  const n = new Bn(V(e)), t = kt(n), l = n._didMount();
  return ne(
    () => V(e).getScrollElement(),
    (o) => {
      o && n._willUpdate();
    },
    {
      immediate: !0
    }
  ), ne(
    () => V(e),
    (o) => {
      n.setOptions({
        ...o,
        onChange: (a, i) => {
          var r;
          ct(t), (r = o.onChange) == null || r.call(o, a, i);
        }
      }), n._willUpdate(), ct(t);
    },
    {
      immediate: !0
    }
  ), dn(l), t;
}
function Hn(e) {
  return jn(
    p(() => ({
      observeElementRect: Dn,
      observeElementOffset: Mn,
      scrollToFn: Nn,
      ...V(e)
    }))
  );
}
function Ot(e, n, t) {
  let l = k(t == null ? void 0 : t.value), o = p(() => e.value !== void 0);
  return [p(() => o.value ? e.value : l.value), function(a) {
    return o.value || (l.value = a), n == null ? void 0 : n(a);
  }];
}
function at(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((n) => setTimeout(() => {
    throw n;
  }));
}
function be() {
  let e = [], n = { addEventListener(t, l, o, a) {
    return t.addEventListener(l, o, a), n.add(() => t.removeEventListener(l, o, a));
  }, requestAnimationFrame(...t) {
    let l = requestAnimationFrame(...t);
    n.add(() => cancelAnimationFrame(l));
  }, nextFrame(...t) {
    n.requestAnimationFrame(() => {
      n.requestAnimationFrame(...t);
    });
  }, setTimeout(...t) {
    let l = setTimeout(...t);
    n.add(() => clearTimeout(l));
  }, microTask(...t) {
    let l = { current: !0 };
    return at(() => {
      l.current && t[0]();
    }), n.add(() => {
      l.current = !1;
    });
  }, style(t, l, o) {
    let a = t.style.getPropertyValue(l);
    return Object.assign(t.style, { [l]: o }), this.add(() => {
      Object.assign(t.style, { [l]: a });
    });
  }, group(t) {
    let l = be();
    return t(l), this.add(() => l.dispose());
  }, add(t) {
    return e.push(t), () => {
      let l = e.indexOf(t);
      if (l >= 0) for (let o of e.splice(l, 1)) o();
    };
  }, dispose() {
    for (let t of e.splice(0)) t();
  } };
  return n;
}
function Un() {
  let e = be();
  return le(() => e.dispose()), e;
}
function Wn() {
  let e = Un();
  return (n) => {
    e.dispose(), e.nextFrame(n);
  };
}
var ft;
let Kn = Symbol("headlessui.useid"), qn = 0;
const re = (ft = dt.useId) != null ? ft : function() {
  return dt.inject(Kn, () => `${++qn}`)();
};
function E(e) {
  var n;
  if (e == null || e.value == null) return null;
  let t = (n = e.value.$el) != null ? n : e.value;
  return t instanceof Node ? t : null;
}
function ee(e, n, ...t) {
  if (e in n) {
    let o = n[e];
    return typeof o == "function" ? o(...t) : o;
  }
  let l = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((o) => `"${o}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(l, ee), l;
}
var Gn = Object.defineProperty, Yn = (e, n, t) => n in e ? Gn(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, vt = (e, n, t) => (Yn(e, typeof n != "symbol" ? n + "" : n, t), t);
let Xn = class {
  constructor() {
    vt(this, "current", this.detect()), vt(this, "currentId", 0);
  }
  set(n) {
    this.current !== n && (this.currentId = 0, this.current = n);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}, De = new Xn();
function xe(e) {
  if (De.isServer) return null;
  if (e instanceof Node) return e.ownerDocument;
  if (e != null && e.hasOwnProperty("value")) {
    let n = E(e);
    if (n) return n.ownerDocument;
  }
  return document;
}
let Ze = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var ge = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(ge || {}), _t = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(_t || {}), Zn = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(Zn || {});
function Jn(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(Ze)).sort((n, t) => Math.sign((n.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var Ct = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(Ct || {});
function Qn(e, n = 0) {
  var t;
  return e === ((t = xe(e)) == null ? void 0 : t.body) ? !1 : ee(n, { 0() {
    return e.matches(Ze);
  }, 1() {
    let l = e;
    for (; l !== null; ) {
      if (l.matches(Ze)) return !0;
      l = l.parentElement;
    }
    return !1;
  } });
}
var eo = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(eo || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function Ee(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let to = ["textarea", "input"].join(",");
function no(e) {
  var n, t;
  return (t = (n = e == null ? void 0 : e.matches) == null ? void 0 : n.call(e, to)) != null ? t : !1;
}
function It(e, n = (t) => t) {
  return e.slice().sort((t, l) => {
    let o = n(t), a = n(l);
    if (o === null || a === null) return 0;
    let i = o.compareDocumentPosition(a);
    return i & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : i & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function je(e, n, { sorted: t = !0, relativeTo: l = null, skipElements: o = [] } = {}) {
  var a;
  let i = (a = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e == null ? void 0 : e.ownerDocument) != null ? a : document, r = Array.isArray(e) ? t ? It(e) : e : Jn(e);
  o.length > 0 && r.length > 1 && (r = r.filter((h) => !o.includes(h))), l = l ?? i.activeElement;
  let s = (() => {
    if (n & 5) return 1;
    if (n & 10) return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), u = (() => {
    if (n & 1) return 0;
    if (n & 2) return Math.max(0, r.indexOf(l)) - 1;
    if (n & 4) return Math.max(0, r.indexOf(l)) + 1;
    if (n & 8) return r.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), d = n & 32 ? { preventScroll: !0 } : {}, c = 0, f = r.length, b;
  do {
    if (c >= f || c + f <= 0) return 0;
    let h = u + c;
    if (n & 16) h = (h + f) % f;
    else {
      if (h < 0) return 3;
      if (h >= f) return 1;
    }
    b = r[h], b == null || b.focus(d), c += s;
  } while (b !== i.activeElement);
  return n & 6 && no(b) && b.select(), 2;
}
function Rt() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function oo() {
  return /Android/gi.test(window.navigator.userAgent);
}
function zt() {
  return Rt() || oo();
}
function Ne(e, n, t) {
  De.isServer || q((l) => {
    document.addEventListener(e, n, t), l(() => document.removeEventListener(e, n, t));
  });
}
function Pt(e, n, t) {
  De.isServer || q((l) => {
    window.addEventListener(e, n, t), l(() => window.removeEventListener(e, n, t));
  });
}
function Lt(e, n, t = p(() => !0)) {
  function l(a, i) {
    if (!t.value || a.defaultPrevented) return;
    let r = i(a);
    if (r === null || !r.getRootNode().contains(r)) return;
    let s = function u(d) {
      return typeof d == "function" ? u(d()) : Array.isArray(d) || d instanceof Set ? d : [d];
    }(e);
    for (let u of s) {
      if (u === null) continue;
      let d = u instanceof HTMLElement ? u : E(u);
      if (d != null && d.contains(r) || a.composed && a.composedPath().includes(d)) return;
    }
    return !Qn(r, Ct.Loose) && r.tabIndex !== -1 && a.preventDefault(), n(a, r);
  }
  let o = k(null);
  Ne("pointerdown", (a) => {
    var i, r;
    t.value && (o.value = ((r = (i = a.composedPath) == null ? void 0 : i.call(a)) == null ? void 0 : r[0]) || a.target);
  }, !0), Ne("mousedown", (a) => {
    var i, r;
    t.value && (o.value = ((r = (i = a.composedPath) == null ? void 0 : i.call(a)) == null ? void 0 : r[0]) || a.target);
  }, !0), Ne("click", (a) => {
    zt() || o.value && (l(a, () => o.value), o.value = null);
  }, !0), Ne("touchend", (a) => l(a, () => a.target instanceof HTMLElement ? a.target : null), !0), Pt("blur", (a) => l(a, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function mt(e, n) {
  if (e) return e;
  let t = n ?? "button";
  if (typeof t == "string" && t.toLowerCase() === "button") return "button";
}
function Dt(e, n) {
  let t = k(mt(e.value.type, e.value.as));
  return j(() => {
    t.value = mt(e.value.type, e.value.as);
  }), q(() => {
    var l;
    t.value || E(n) && E(n) instanceof HTMLButtonElement && !((l = E(n)) != null && l.hasAttribute("type")) && (t.value = "button");
  }), t;
}
function gt(e) {
  return [e.screenX, e.screenY];
}
function lo() {
  let e = k([-1, -1]);
  return { wasMoved(n) {
    let t = gt(n);
    return e.value[0] === t[0] && e.value[1] === t[1] ? !1 : (e.value = t, !0);
  }, update(n) {
    e.value = gt(n);
  } };
}
function ro({ container: e, accept: n, walk: t, enabled: l }) {
  q(() => {
    let o = e.value;
    if (!o || l !== void 0 && !l.value) return;
    let a = xe(e);
    if (!a) return;
    let i = Object.assign((s) => n(s), { acceptNode: n }), r = a.createTreeWalker(o, NodeFilter.SHOW_ELEMENT, i, !1);
    for (; r.nextNode(); ) t(r.currentNode);
  });
}
var ye = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(ye || {}), he = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(he || {});
function H({ visible: e = !0, features: n = 0, ourProps: t, theirProps: l, ...o }) {
  var a;
  let i = Mt(l, t), r = Object.assign(o, { props: i });
  if (e || n & 2 && i.static) return Ge(r);
  if (n & 1) {
    let s = (a = i.unmount) == null || a ? 0 : 1;
    return ee(s, { 0() {
      return null;
    }, 1() {
      return Ge({ ...o, props: { ...i, hidden: !0, style: { display: "none" } } });
    } });
  }
  return Ge(r);
}
function Ge({ props: e, attrs: n, slots: t, slot: l, name: o }) {
  var a, i;
  let { as: r, ...s } = _e(e, ["unmount", "static"]), u = (a = t.default) == null ? void 0 : a.call(t, l), d = {};
  if (l) {
    let c = !1, f = [];
    for (let [b, h] of Object.entries(l)) typeof h == "boolean" && (c = !0), h === !0 && f.push(b);
    c && (d["data-headlessui-state"] = f.join(" "));
  }
  if (r === "template") {
    if (u = Ft(u ?? []), Object.keys(s).length > 0 || Object.keys(n).length > 0) {
      let [c, ...f] = u ?? [];
      if (!ao(c) || f.length > 0) throw new Error(['Passing props on "template"!', "", `The current component <${o} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(s).concat(Object.keys(n)).map((w) => w.trim()).filter((w, C, P) => P.indexOf(w) === C).sort((w, C) => w.localeCompare(C)).map((w) => `  - ${w}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((w) => `  - ${w}`).join(`
`)].join(`
`));
      let b = Mt((i = c.props) != null ? i : {}, s, d), h = wt(c, b, !0);
      for (let w in b) w.startsWith("on") && (h.props || (h.props = {}), h.props[w] = b[w]);
      return h;
    }
    return Array.isArray(u) && u.length === 1 ? u[0] : u;
  }
  return N(r, Object.assign({}, s, d), { default: () => u });
}
function Ft(e) {
  return e.flatMap((n) => n.type === ue ? Ft(n.children) : [n]);
}
function Mt(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let n = {}, t = {};
  for (let l of e) for (let o in l) o.startsWith("on") && typeof l[o] == "function" ? (t[o] != null || (t[o] = []), t[o].push(l[o])) : n[o] = l[o];
  if (n.disabled || n["aria-disabled"]) return Object.assign(n, Object.fromEntries(Object.keys(t).map((l) => [l, void 0])));
  for (let l in t) Object.assign(n, { [l](o, ...a) {
    let i = t[l];
    for (let r of i) {
      if (o instanceof Event && o.defaultPrevented) return;
      r(o, ...a);
    }
  } });
  return n;
}
function At(e) {
  let n = Object.assign({}, e);
  for (let t in n) n[t] === void 0 && delete n[t];
  return n;
}
function _e(e, n = []) {
  let t = Object.assign({}, e);
  for (let l of n) l in t && delete t[l];
  return t;
}
function ao(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
var Oe = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(Oe || {});
let Pe = R({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(e, { slots: n, attrs: t }) {
  return () => {
    var l;
    let { features: o, ...a } = e, i = { "aria-hidden": (o & 2) === 2 ? !0 : (l = a["aria-hidden"]) != null ? l : void 0, hidden: (o & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(o & 4) === 4 && (o & 2) !== 2 && { display: "none" } } };
    return H({ ourProps: i, theirProps: a, slot: {}, attrs: t, slots: n, name: "Hidden" });
  };
} }), Nt = Symbol("Context");
var X = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(X || {});
function io() {
  return Ue() !== null;
}
function Ue() {
  return Z(Nt, null);
}
function Bt(e) {
  te(Nt, e);
}
var J = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(J || {}), Vt = ((e) => (e[e.Left = 0] = "Left", e[e.Right = 2] = "Right", e))(Vt || {});
function so(e) {
  function n() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", n));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", n), n());
}
let pe = [];
so(() => {
  function e(n) {
    n.target instanceof HTMLElement && n.target !== document.body && pe[0] !== n.target && (pe.unshift(n.target), pe = pe.filter((t) => t != null && t.isConnected), pe.splice(10));
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function uo(e) {
  throw new Error("Unexpected object: " + e);
}
var G = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(G || {});
function ht(e, n) {
  let t = n.resolveItems();
  if (t.length <= 0) return null;
  let l = n.resolveActiveIndex(), o = l ?? -1;
  switch (e.focus) {
    case 0: {
      for (let a = 0; a < t.length; ++a) if (!n.resolveDisabled(t[a], a, t)) return a;
      return l;
    }
    case 1: {
      o === -1 && (o = t.length);
      for (let a = o - 1; a >= 0; --a) if (!n.resolveDisabled(t[a], a, t)) return a;
      return l;
    }
    case 2: {
      for (let a = o + 1; a < t.length; ++a) if (!n.resolveDisabled(t[a], a, t)) return a;
      return l;
    }
    case 3: {
      for (let a = t.length - 1; a >= 0; --a) if (!n.resolveDisabled(t[a], a, t)) return a;
      return l;
    }
    case 4: {
      for (let a = 0; a < t.length; ++a) if (n.resolveId(t[a], a, t) === e.id) return a;
      return l;
    }
    case 5:
      return null;
    default:
      uo(e);
  }
}
function jt(e = {}, n = null, t = []) {
  for (let [l, o] of Object.entries(e)) Ut(t, Ht(n, l), o);
  return t;
}
function Ht(e, n) {
  return e ? e + "[" + n + "]" : n;
}
function Ut(e, n, t) {
  if (Array.isArray(t)) for (let [l, o] of t.entries()) Ut(e, Ht(n, l.toString()), o);
  else t instanceof Date ? e.push([n, t.toISOString()]) : typeof t == "boolean" ? e.push([n, t ? "1" : "0"]) : typeof t == "string" ? e.push([n, t]) : typeof t == "number" ? e.push([n, `${t}`]) : t == null ? e.push([n, ""]) : jt(t, n, e);
}
function co(e) {
  var n, t;
  let l = (n = e == null ? void 0 : e.form) != null ? n : e.closest("form");
  if (l) {
    for (let o of l.elements) if (o !== e && (o.tagName === "INPUT" && o.type === "submit" || o.tagName === "BUTTON" && o.type === "submit" || o.nodeName === "INPUT" && o.type === "image")) {
      o.click();
      return;
    }
    (t = l.requestSubmit) == null || t.call(l);
  }
}
function po(e, n) {
  return e === n;
}
var fo = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(fo || {}), vo = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(vo || {}), mo = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Focus = 1] = "Focus", e[e.Other = 2] = "Other", e))(mo || {});
let Wt = Symbol("ComboboxContext");
function Te(e) {
  let n = Z(Wt, null);
  if (n === null) {
    let t = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, Te), t;
  }
  return n;
}
let Kt = Symbol("VirtualContext"), go = R({ name: "VirtualProvider", setup(e, { slots: n }) {
  let t = Te("VirtualProvider"), l = p(() => {
    let r = E(t.optionsRef);
    if (!r) return { start: 0, end: 0 };
    let s = window.getComputedStyle(r);
    return { start: parseFloat(s.paddingBlockStart || s.paddingTop), end: parseFloat(s.paddingBlockEnd || s.paddingBottom) };
  }), o = Hn(p(() => ({ scrollPaddingStart: l.value.start, scrollPaddingEnd: l.value.end, count: t.virtual.value.options.length, estimateSize() {
    return 40;
  }, getScrollElement() {
    return E(t.optionsRef);
  }, overscan: 12 }))), a = p(() => {
    var r;
    return (r = t.virtual.value) == null ? void 0 : r.options;
  }), i = k(0);
  return ne([a], () => {
    i.value += 1;
  }), te(Kt, t.virtual.value ? o : null), () => [N("div", { style: { position: "relative", width: "100%", height: `${o.value.getTotalSize()}px` }, ref: (r) => {
    if (r) {
      if (typeof process < "u" && process.env.JEST_WORKER_ID !== void 0 || t.activationTrigger.value === 0) return;
      t.activeOptionIndex.value !== null && t.virtual.value.options.length > t.activeOptionIndex.value && o.value.scrollToIndex(t.activeOptionIndex.value);
    }
  } }, o.value.getVirtualItems().map((r) => wt(n.default({ option: t.virtual.value.options[r.index], open: t.comboboxState.value === 0 })[0], { key: `${i.value}-${r.index}`, "data-index": r.index, "aria-setsize": t.virtual.value.options.length, "aria-posinset": r.index + 1, style: { position: "absolute", top: 0, left: 0, transform: `translateY(${r.start}px)`, overflowAnchor: "none" } })))];
} }), ho = R({ name: "Combobox", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], nullable: !0, default: null }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, nullable: { type: Boolean, default: !1 }, multiple: { type: [Boolean], default: !1 }, immediate: { type: [Boolean], default: !1 }, virtual: { type: Object, default: null } }, inheritAttrs: !1, setup(e, { slots: n, attrs: t, emit: l }) {
  let o = k(1), a = k(null), i = k(null), r = k(null), s = k(null), u = k({ static: !1, hold: !1 }), d = k([]), c = k(null), f = k(2), b = k(!1);
  function h(v = (x) => x) {
    let x = c.value !== null ? d.value[c.value] : null, O = v(d.value.slice()), $ = O.length > 0 && O[0].dataRef.order.value !== null ? O.sort((L, W) => L.dataRef.order.value - W.dataRef.order.value) : It(O, (L) => E(L.dataRef.domRef)), M = x ? $.indexOf(x) : null;
    return M === -1 && (M = null), { options: $, activeOptionIndex: M };
  }
  let w = p(() => e.multiple ? 1 : 0), C = p(() => e.nullable), [P, m] = Ot(p(() => e.modelValue), (v) => l("update:modelValue", v), p(() => e.defaultValue)), I = p(() => P.value === void 0 ? ee(w.value, { 1: [], 0: void 0 }) : P.value), K = null, y = null;
  function z(v) {
    return ee(w.value, { 0() {
      return m == null ? void 0 : m(v);
    }, 1: () => {
      let x = ve(g.value.value).slice(), O = ve(v), $ = x.findIndex((M) => g.compare(O, ve(M)));
      return $ === -1 ? x.push(O) : x.splice($, 1), m == null ? void 0 : m(x);
    } });
  }
  let D = p(() => {
  });
  ne([D], ([v], [x]) => {
    if (g.virtual.value && v && x && c.value !== null) {
      let O = v.indexOf(x[c.value]);
      O !== -1 ? c.value = O : c.value = null;
    }
  });
  let g = { comboboxState: o, value: I, mode: w, compare(v, x) {
    if (typeof e.by == "string") {
      let O = e.by;
      return (v == null ? void 0 : v[O]) === (x == null ? void 0 : x[O]);
    }
    return e.by === null ? po(v, x) : e.by(v, x);
  }, calculateIndex(v) {
    return g.virtual.value ? e.by === null ? g.virtual.value.options.indexOf(v) : g.virtual.value.options.findIndex((x) => g.compare(x, v)) : d.value.findIndex((x) => g.compare(x.dataRef.value, v));
  }, defaultValue: p(() => e.defaultValue), nullable: C, immediate: p(() => !1), virtual: p(() => null), inputRef: i, labelRef: a, buttonRef: r, optionsRef: s, disabled: p(() => e.disabled), options: d, change(v) {
    m(v);
  }, activeOptionIndex: p(() => {
    if (b.value && c.value === null && (g.virtual.value ? g.virtual.value.options.length > 0 : d.value.length > 0)) {
      if (g.virtual.value) {
        let x = g.virtual.value.options.findIndex((O) => {
          var $;
          return !(($ = g.virtual.value) != null && $.disabled(O));
        });
        if (x !== -1) return x;
      }
      let v = d.value.findIndex((x) => !x.dataRef.disabled);
      if (v !== -1) return v;
    }
    return c.value;
  }), activationTrigger: f, optionsPropsRef: u, closeCombobox() {
    b.value = !1, !e.disabled && o.value !== 1 && (o.value = 1, c.value = null);
  }, openCombobox() {
    if (b.value = !0, !e.disabled && o.value !== 0) {
      if (g.value.value) {
        let v = g.calculateIndex(g.value.value);
        v !== -1 && (c.value = v);
      }
      o.value = 0;
    }
  }, setActivationTrigger(v) {
    f.value = v;
  }, goToOption(v, x, O) {
    b.value = !1, K !== null && cancelAnimationFrame(K), K = requestAnimationFrame(() => {
      if (e.disabled || s.value && !u.value.static && o.value === 1) return;
      if (g.virtual.value) {
        c.value = v === G.Specific ? x : ht({ focus: v }, { resolveItems: () => g.virtual.value.options, resolveActiveIndex: () => {
          var L, W;
          return (W = (L = g.activeOptionIndex.value) != null ? L : g.virtual.value.options.findIndex((ae) => {
            var fe;
            return !((fe = g.virtual.value) != null && fe.disabled(ae));
          })) != null ? W : null;
        }, resolveDisabled: (L) => g.virtual.value.disabled(L), resolveId() {
          throw new Error("Function not implemented.");
        } }), f.value = O ?? 2;
        return;
      }
      let $ = h();
      if ($.activeOptionIndex === null) {
        let L = $.options.findIndex((W) => !W.dataRef.disabled);
        L !== -1 && ($.activeOptionIndex = L);
      }
      let M = v === G.Specific ? x : ht({ focus: v }, { resolveItems: () => $.options, resolveActiveIndex: () => $.activeOptionIndex, resolveId: (L) => L.id, resolveDisabled: (L) => L.dataRef.disabled });
      c.value = M, f.value = O ?? 2, d.value = $.options;
    });
  }, selectOption(v) {
    let x = d.value.find(($) => $.id === v);
    if (!x) return;
    let { dataRef: O } = x;
    z(O.value);
  }, selectActiveOption() {
    if (g.activeOptionIndex.value !== null) {
      if (g.virtual.value) z(g.virtual.value.options[g.activeOptionIndex.value]);
      else {
        let { dataRef: v } = d.value[g.activeOptionIndex.value];
        z(v.value);
      }
      g.goToOption(G.Specific, g.activeOptionIndex.value);
    }
  }, registerOption(v, x) {
    let O = Et({ id: v, dataRef: x });
    if (g.virtual.value) {
      d.value.push(O);
      return;
    }
    y && cancelAnimationFrame(y);
    let $ = h((M) => (M.push(O), M));
    c.value === null && g.isSelected(x.value.value) && ($.activeOptionIndex = $.options.indexOf(O)), d.value = $.options, c.value = $.activeOptionIndex, f.value = 2, $.options.some((M) => !E(M.dataRef.domRef)) && (y = requestAnimationFrame(() => {
      let M = h();
      d.value = M.options, c.value = M.activeOptionIndex;
    }));
  }, unregisterOption(v, x) {
    if (K !== null && cancelAnimationFrame(K), x && (b.value = !0), g.virtual.value) {
      d.value = d.value.filter(($) => $.id !== v);
      return;
    }
    let O = h(($) => {
      let M = $.findIndex((L) => L.id === v);
      return M !== -1 && $.splice(M, 1), $;
    });
    d.value = O.options, c.value = O.activeOptionIndex, f.value = 2;
  }, isSelected(v) {
    return ee(w.value, { 0: () => g.compare(ve(g.value.value), ve(v)), 1: () => ve(g.value.value).some((x) => g.compare(ve(x), ve(v))) });
  }, isActive(v) {
    return c.value === g.calculateIndex(v);
  } };
  Lt([i, r, s], () => g.closeCombobox(), p(() => o.value === 0)), te(Wt, g), Bt(p(() => ee(o.value, { 0: X.Open, 1: X.Closed })));
  let F = p(() => {
    var v;
    return (v = E(i)) == null ? void 0 : v.closest("form");
  });
  return j(() => {
    ne([F], () => {
      if (!F.value || e.defaultValue === void 0) return;
      function v() {
        g.change(e.defaultValue);
      }
      return F.value.addEventListener("reset", v), () => {
        var x;
        (x = F.value) == null || x.removeEventListener("reset", v);
      };
    }, { immediate: !0 });
  }), () => {
    var v, x, O;
    let { name: $, disabled: M, form: L, ...W } = e, ae = { open: o.value === 0, disabled: M, activeIndex: g.activeOptionIndex.value, activeOption: g.activeOptionIndex.value === null ? null : g.virtual.value ? g.virtual.value.options[(v = g.activeOptionIndex.value) != null ? v : 0] : (O = (x = g.options.value[g.activeOptionIndex.value]) == null ? void 0 : x.dataRef.value) != null ? O : null, value: I.value };
    return N(ue, [...$ != null && I.value != null ? jt({ [$]: I.value }).map(([fe, Me]) => N(Pe, At({ features: Oe.Hidden, key: fe, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: L, disabled: M, name: fe, value: Me }))) : [], H({ theirProps: { ...t, ..._e(W, ["by", "defaultValue", "immediate", "modelValue", "multiple", "nullable", "onUpdate:modelValue", "virtual"]) }, ourProps: {}, slot: ae, slots: n, attrs: t, name: "Combobox" })]);
  };
} }), bo = R({ name: "ComboboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: null } }, setup(e, { attrs: n, slots: t }) {
  var l;
  let o = (l = e.id) != null ? l : `headlessui-combobox-label-${re()}`, a = Te("ComboboxLabel");
  function i() {
    var r;
    (r = E(a.inputRef)) == null || r.focus({ preventScroll: !0 });
  }
  return () => {
    let r = { open: a.comboboxState.value === 0, disabled: a.disabled.value }, { ...s } = e, u = { id: o, ref: a.labelRef, onClick: i };
    return H({ ourProps: u, theirProps: s, slot: r, attrs: n, slots: t, name: "ComboboxLabel" });
  };
} }), yo = R({ name: "ComboboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(e, { attrs: n, slots: t, expose: l }) {
  var o;
  let a = (o = e.id) != null ? o : `headlessui-combobox-button-${re()}`, i = Te("ComboboxButton");
  l({ el: i.buttonRef, $el: i.buttonRef });
  function r(d) {
    i.disabled.value || (i.comboboxState.value === 0 ? i.closeCombobox() : (d.preventDefault(), i.openCombobox()), me(() => {
      var c;
      return (c = E(i.inputRef)) == null ? void 0 : c.focus({ preventScroll: !0 });
    }));
  }
  function s(d) {
    switch (d.key) {
      case J.ArrowDown:
        d.preventDefault(), d.stopPropagation(), i.comboboxState.value === 1 && i.openCombobox(), me(() => {
          var c;
          return (c = i.inputRef.value) == null ? void 0 : c.focus({ preventScroll: !0 });
        });
        return;
      case J.ArrowUp:
        d.preventDefault(), d.stopPropagation(), i.comboboxState.value === 1 && (i.openCombobox(), me(() => {
          i.value.value || i.goToOption(G.Last);
        })), me(() => {
          var c;
          return (c = i.inputRef.value) == null ? void 0 : c.focus({ preventScroll: !0 });
        });
        return;
      case J.Escape:
        if (i.comboboxState.value !== 0) return;
        d.preventDefault(), i.optionsRef.value && !i.optionsPropsRef.value.static && d.stopPropagation(), i.closeCombobox(), me(() => {
          var c;
          return (c = i.inputRef.value) == null ? void 0 : c.focus({ preventScroll: !0 });
        });
        return;
    }
  }
  let u = Dt(p(() => ({ as: e.as, type: n.type })), i.buttonRef);
  return () => {
    var d, c;
    let f = { open: i.comboboxState.value === 0, disabled: i.disabled.value, value: i.value.value }, { ...b } = e, h = { ref: i.buttonRef, id: a, type: u.value, tabindex: "-1", "aria-haspopup": "listbox", "aria-controls": (d = E(i.optionsRef)) == null ? void 0 : d.id, "aria-expanded": i.comboboxState.value === 0, "aria-labelledby": i.labelRef.value ? [(c = E(i.labelRef)) == null ? void 0 : c.id, a].join(" ") : void 0, disabled: i.disabled.value === !0 ? !0 : void 0, onKeydown: s, onClick: r };
    return H({ ourProps: h, theirProps: b, slot: f, attrs: n, slots: t, name: "ComboboxButton" });
  };
} }), xo = R({ name: "ComboboxInput", props: { as: { type: [Object, String], default: "input" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, displayValue: { type: Function }, defaultValue: { type: String, default: void 0 }, id: { type: String, default: null } }, emits: { change: (e) => !0 }, setup(e, { emit: n, attrs: t, slots: l, expose: o }) {
  var a;
  let i = (a = e.id) != null ? a : `headlessui-combobox-input-${re()}`, r = Te("ComboboxInput"), s = p(() => xe(E(r.inputRef))), u = { value: !1 };
  o({ el: r.inputRef, $el: r.inputRef });
  function d() {
    r.change(null);
    let y = E(r.optionsRef);
    y && (y.scrollTop = 0), r.goToOption(G.Nothing);
  }
  let c = p(() => {
    var y;
    let z = r.value.value;
    return E(r.inputRef) ? typeof e.displayValue < "u" && z !== void 0 ? (y = e.displayValue(z)) != null ? y : "" : typeof z == "string" ? z : "" : "";
  });
  j(() => {
    ne([c, r.comboboxState, s], ([y, z], [D, g]) => {
      if (u.value) return;
      let F = E(r.inputRef);
      F && ((g === 0 && z === 1 || y !== D) && (F.value = y), requestAnimationFrame(() => {
        var v;
        if (u.value || !F || ((v = s.value) == null ? void 0 : v.activeElement) !== F) return;
        let { selectionStart: x, selectionEnd: O } = F;
        Math.abs((O ?? 0) - (x ?? 0)) === 0 && x === 0 && F.setSelectionRange(F.value.length, F.value.length);
      }));
    }, { immediate: !0 }), ne([r.comboboxState], ([y], [z]) => {
      if (y === 0 && z === 1) {
        if (u.value) return;
        let D = E(r.inputRef);
        if (!D) return;
        let g = D.value, { selectionStart: F, selectionEnd: v, selectionDirection: x } = D;
        D.value = "", D.value = g, x !== null ? D.setSelectionRange(F, v, x) : D.setSelectionRange(F, v);
      }
    });
  });
  let f = k(!1);
  function b() {
    f.value = !0;
  }
  function h() {
    be().nextFrame(() => {
      f.value = !1;
    });
  }
  let w = Wn();
  function C(y) {
    switch (u.value = !0, w(() => {
      u.value = !1;
    }), y.key) {
      case J.Enter:
        if (u.value = !1, r.comboboxState.value !== 0 || f.value) return;
        if (y.preventDefault(), y.stopPropagation(), r.activeOptionIndex.value === null) {
          r.closeCombobox();
          return;
        }
        r.selectActiveOption(), r.mode.value === 0 && r.closeCombobox();
        break;
      case J.ArrowDown:
        return u.value = !1, y.preventDefault(), y.stopPropagation(), ee(r.comboboxState.value, { 0: () => r.goToOption(G.Next), 1: () => r.openCombobox() });
      case J.ArrowUp:
        return u.value = !1, y.preventDefault(), y.stopPropagation(), ee(r.comboboxState.value, { 0: () => r.goToOption(G.Previous), 1: () => {
          r.openCombobox(), me(() => {
            r.value.value || r.goToOption(G.Last);
          });
        } });
      case J.Home:
        if (y.shiftKey) break;
        return u.value = !1, y.preventDefault(), y.stopPropagation(), r.goToOption(G.First);
      case J.PageUp:
        return u.value = !1, y.preventDefault(), y.stopPropagation(), r.goToOption(G.First);
      case J.End:
        if (y.shiftKey) break;
        return u.value = !1, y.preventDefault(), y.stopPropagation(), r.goToOption(G.Last);
      case J.PageDown:
        return u.value = !1, y.preventDefault(), y.stopPropagation(), r.goToOption(G.Last);
      case J.Escape:
        if (u.value = !1, r.comboboxState.value !== 0) return;
        y.preventDefault(), r.optionsRef.value && !r.optionsPropsRef.value.static && y.stopPropagation(), r.nullable.value && r.mode.value === 0 && r.value.value === null && d(), r.closeCombobox();
        break;
      case J.Tab:
        if (u.value = !1, r.comboboxState.value !== 0) return;
        r.mode.value === 0 && r.activationTrigger.value !== 1 && r.selectActiveOption(), r.closeCombobox();
        break;
    }
  }
  function P(y) {
    n("change", y), r.nullable.value && r.mode.value === 0 && y.target.value === "" && d(), r.openCombobox();
  }
  function m(y) {
    var z, D, g;
    let F = (z = y.relatedTarget) != null ? z : pe.find((v) => v !== y.currentTarget);
    if (u.value = !1, !((D = E(r.optionsRef)) != null && D.contains(F)) && !((g = E(r.buttonRef)) != null && g.contains(F)) && r.comboboxState.value === 0) return y.preventDefault(), r.mode.value === 0 && (r.nullable.value && r.value.value === null ? d() : r.activationTrigger.value !== 1 && r.selectActiveOption()), r.closeCombobox();
  }
  function I(y) {
    var z, D, g;
    let F = (z = y.relatedTarget) != null ? z : pe.find((v) => v !== y.currentTarget);
    (D = E(r.buttonRef)) != null && D.contains(F) || (g = E(r.optionsRef)) != null && g.contains(F) || r.disabled.value || r.immediate.value && r.comboboxState.value !== 0 && (r.openCombobox(), be().nextFrame(() => {
      r.setActivationTrigger(1);
    }));
  }
  let K = p(() => {
    var y, z, D, g;
    return (g = (D = (z = e.defaultValue) != null ? z : r.defaultValue.value !== void 0 ? (y = e.displayValue) == null ? void 0 : y.call(e, r.defaultValue.value) : null) != null ? D : r.defaultValue.value) != null ? g : "";
  });
  return () => {
    var y, z, D, g, F, v, x;
    let O = { open: r.comboboxState.value === 0 }, { displayValue: $, onChange: M, ...L } = e, W = { "aria-controls": (y = r.optionsRef.value) == null ? void 0 : y.id, "aria-expanded": r.comboboxState.value === 0, "aria-activedescendant": r.activeOptionIndex.value === null ? void 0 : r.virtual.value ? (z = r.options.value.find((ae) => !r.virtual.value.disabled(ae.dataRef.value) && r.compare(ae.dataRef.value, r.virtual.value.options[r.activeOptionIndex.value]))) == null ? void 0 : z.id : (D = r.options.value[r.activeOptionIndex.value]) == null ? void 0 : D.id, "aria-labelledby": (v = (g = E(r.labelRef)) == null ? void 0 : g.id) != null ? v : (F = E(r.buttonRef)) == null ? void 0 : F.id, "aria-autocomplete": "list", id: i, onCompositionstart: b, onCompositionend: h, onKeydown: C, onInput: P, onFocus: I, onBlur: m, role: "combobox", type: (x = t.type) != null ? x : "text", tabIndex: 0, ref: r.inputRef, defaultValue: K.value, disabled: r.disabled.value === !0 ? !0 : void 0 };
    return H({ ourProps: W, theirProps: L, slot: O, attrs: t, slots: l, features: ye.RenderStrategy | ye.Static, name: "ComboboxInput" });
  };
} }), ko = R({ name: "ComboboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, hold: { type: [Boolean], default: !1 } }, setup(e, { attrs: n, slots: t, expose: l }) {
  let o = Te("ComboboxOptions"), a = `headlessui-combobox-options-${re()}`;
  l({ el: o.optionsRef, $el: o.optionsRef }), q(() => {
    o.optionsPropsRef.value.static = e.static;
  }), q(() => {
    o.optionsPropsRef.value.hold = e.hold;
  });
  let i = Ue(), r = p(() => i !== null ? (i.value & X.Open) === X.Open : o.comboboxState.value === 0);
  ro({ container: p(() => E(o.optionsRef)), enabled: p(() => o.comboboxState.value === 0), accept(u) {
    return u.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : u.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(u) {
    u.setAttribute("role", "none");
  } });
  function s(u) {
    u.preventDefault();
  }
  return () => {
    var u, d, c;
    let f = { open: o.comboboxState.value === 0 }, b = { "aria-labelledby": (c = (u = E(o.labelRef)) == null ? void 0 : u.id) != null ? c : (d = E(o.buttonRef)) == null ? void 0 : d.id, id: a, ref: o.optionsRef, role: "listbox", "aria-multiselectable": o.mode.value === 1 ? !0 : void 0, onMousedown: s }, h = _e(e, ["hold"]);
    return H({ ourProps: b, theirProps: h, slot: f, attrs: n, slots: o.virtual.value && o.comboboxState.value === 0 ? { ...t, default: () => [N(go, {}, t.default)] } : t, features: ye.RenderStrategy | ye.Static, visible: r.value, name: "ComboboxOptions" });
  };
} }), wo = R({ name: "ComboboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, order: { type: [Number], default: null } }, setup(e, { slots: n, attrs: t, expose: l }) {
  let o = Te("ComboboxOption"), a = `headlessui-combobox-option-${re()}`, i = k(null), r = p(() => e.disabled);
  l({ el: i, $el: i });
  let s = p(() => {
    var m;
    return o.virtual.value ? o.activeOptionIndex.value === o.calculateIndex(e.value) : o.activeOptionIndex.value === null ? !1 : ((m = o.options.value[o.activeOptionIndex.value]) == null ? void 0 : m.id) === a;
  }), u = p(() => o.isSelected(e.value)), d = Z(Kt, null), c = p(() => ({ disabled: e.disabled, value: e.value, domRef: i, order: p(() => e.order) }));
  j(() => o.registerOption(a, c)), le(() => o.unregisterOption(a, s.value)), q(() => {
    let m = E(i);
    m && (d == null || d.value.measureElement(m));
  }), q(() => {
    o.comboboxState.value === 0 && s.value && (o.virtual.value || o.activationTrigger.value !== 0 && me(() => {
      var m, I;
      return (I = (m = E(i)) == null ? void 0 : m.scrollIntoView) == null ? void 0 : I.call(m, { block: "nearest" });
    }));
  });
  function f(m) {
    m.preventDefault(), m.button === Vt.Left && (r.value || (o.selectOption(a), zt() || requestAnimationFrame(() => {
      var I;
      return (I = E(o.inputRef)) == null ? void 0 : I.focus({ preventScroll: !0 });
    }), o.mode.value === 0 && o.closeCombobox()));
  }
  function b() {
    var m;
    if (e.disabled || (m = o.virtual.value) != null && m.disabled(e.value)) return o.goToOption(G.Nothing);
    let I = o.calculateIndex(e.value);
    o.goToOption(G.Specific, I);
  }
  let h = lo();
  function w(m) {
    h.update(m);
  }
  function C(m) {
    var I;
    if (!h.wasMoved(m) || e.disabled || (I = o.virtual.value) != null && I.disabled(e.value) || s.value) return;
    let K = o.calculateIndex(e.value);
    o.goToOption(G.Specific, K, 0);
  }
  function P(m) {
    var I;
    h.wasMoved(m) && (e.disabled || (I = o.virtual.value) != null && I.disabled(e.value) || s.value && (o.optionsPropsRef.value.hold || o.goToOption(G.Nothing)));
  }
  return () => {
    let { disabled: m } = e, I = { active: s.value, selected: u.value, disabled: m }, K = { id: a, ref: i, role: "option", tabIndex: m === !0 ? void 0 : -1, "aria-disabled": m === !0 ? !0 : void 0, "aria-selected": u.value, disabled: void 0, onMousedown: f, onFocus: b, onPointerenter: w, onMouseenter: w, onPointermove: C, onMousemove: C, onPointerleave: P, onMouseleave: P }, y = _e(e, ["order", "value"]);
    return H({ ourProps: K, theirProps: y, slot: I, attrs: t, slots: n, name: "ComboboxOption" });
  };
} });
function qt(e, n, t, l) {
  De.isServer || q((o) => {
    e = e ?? window, e.addEventListener(n, t, l), o(() => e.removeEventListener(n, t, l));
  });
}
var Re = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(Re || {});
function Eo() {
  let e = k(0);
  return Pt("keydown", (n) => {
    n.key === "Tab" && (e.value = n.shiftKey ? 1 : 0);
  }), e;
}
function Gt(e) {
  if (!e) return /* @__PURE__ */ new Set();
  if (typeof e == "function") return new Set(e());
  let n = /* @__PURE__ */ new Set();
  for (let t of e.value) {
    let l = E(t);
    l instanceof HTMLElement && n.add(l);
  }
  return n;
}
var Yt = ((e) => (e[e.None = 1] = "None", e[e.InitialFocus = 2] = "InitialFocus", e[e.TabLock = 4] = "TabLock", e[e.FocusLock = 8] = "FocusLock", e[e.RestoreFocus = 16] = "RestoreFocus", e[e.All = 30] = "All", e))(Yt || {});
let Ce = Object.assign(R({ name: "FocusTrap", props: { as: { type: [Object, String], default: "div" }, initialFocus: { type: Object, default: null }, features: { type: Number, default: 30 }, containers: { type: [Object, Function], default: k(/* @__PURE__ */ new Set()) } }, inheritAttrs: !1, setup(e, { attrs: n, slots: t, expose: l }) {
  let o = k(null);
  l({ el: o, $el: o });
  let a = p(() => xe(o)), i = k(!1);
  j(() => i.value = !0), le(() => i.value = !1), To({ ownerDocument: a }, p(() => i.value && !!(e.features & 16)));
  let r = $o({ ownerDocument: a, container: o, initialFocus: p(() => e.initialFocus) }, p(() => i.value && !!(e.features & 2)));
  Oo({ ownerDocument: a, container: o, containers: e.containers, previousActiveElement: r }, p(() => i.value && !!(e.features & 8)));
  let s = Eo();
  function u(b) {
    let h = E(o);
    h && ((w) => w())(() => {
      ee(s.value, { [Re.Forwards]: () => {
        je(h, ge.First, { skipElements: [b.relatedTarget] });
      }, [Re.Backwards]: () => {
        je(h, ge.Last, { skipElements: [b.relatedTarget] });
      } });
    });
  }
  let d = k(!1);
  function c(b) {
    b.key === "Tab" && (d.value = !0, requestAnimationFrame(() => {
      d.value = !1;
    }));
  }
  function f(b) {
    if (!i.value) return;
    let h = Gt(e.containers);
    E(o) instanceof HTMLElement && h.add(E(o));
    let w = b.relatedTarget;
    w instanceof HTMLElement && w.dataset.headlessuiFocusGuard !== "true" && (Xt(h, w) || (d.value ? je(E(o), ee(s.value, { [Re.Forwards]: () => ge.Next, [Re.Backwards]: () => ge.Previous }) | ge.WrapAround, { relativeTo: b.target }) : b.target instanceof HTMLElement && Ee(b.target)));
  }
  return () => {
    let b = {}, h = { ref: o, onKeydown: c, onFocusout: f }, { features: w, initialFocus: C, containers: P, ...m } = e;
    return N(ue, [!!(w & 4) && N(Pe, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: u, features: Oe.Focusable }), H({ ourProps: h, theirProps: { ...n, ...m }, slot: b, attrs: n, slots: t, name: "FocusTrap" }), !!(w & 4) && N(Pe, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: u, features: Oe.Focusable })]);
  };
} }), { features: Yt });
function So(e) {
  let n = k(pe.slice());
  return ne([e], ([t], [l]) => {
    l === !0 && t === !1 ? at(() => {
      n.value.splice(0);
    }) : l === !1 && t === !0 && (n.value = pe.slice());
  }, { flush: "post" }), () => {
    var t;
    return (t = n.value.find((l) => l != null && l.isConnected)) != null ? t : null;
  };
}
function To({ ownerDocument: e }, n) {
  let t = So(n);
  j(() => {
    q(() => {
      var l, o;
      n.value || ((l = e.value) == null ? void 0 : l.activeElement) === ((o = e.value) == null ? void 0 : o.body) && Ee(t());
    }, { flush: "post" });
  }), le(() => {
    n.value && Ee(t());
  });
}
function $o({ ownerDocument: e, container: n, initialFocus: t }, l) {
  let o = k(null), a = k(!1);
  return j(() => a.value = !0), le(() => a.value = !1), j(() => {
    ne([n, t, l], (i, r) => {
      if (i.every((u, d) => (r == null ? void 0 : r[d]) === u) || !l.value) return;
      let s = E(n);
      s && at(() => {
        var u, d;
        if (!a.value) return;
        let c = E(t), f = (u = e.value) == null ? void 0 : u.activeElement;
        if (c) {
          if (c === f) {
            o.value = f;
            return;
          }
        } else if (s.contains(f)) {
          o.value = f;
          return;
        }
        c ? Ee(c) : je(s, ge.First | ge.NoScroll) === _t.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), o.value = (d = e.value) == null ? void 0 : d.activeElement;
      });
    }, { immediate: !0, flush: "post" });
  }), o;
}
function Oo({ ownerDocument: e, container: n, containers: t, previousActiveElement: l }, o) {
  var a;
  qt((a = e.value) == null ? void 0 : a.defaultView, "focus", (i) => {
    if (!o.value) return;
    let r = Gt(t);
    E(n) instanceof HTMLElement && r.add(E(n));
    let s = l.value;
    if (!s) return;
    let u = i.target;
    u && u instanceof HTMLElement ? Xt(r, u) ? (l.value = u, Ee(u)) : (i.preventDefault(), i.stopPropagation(), Ee(s)) : Ee(l.value);
  }, !0);
}
function Xt(e, n) {
  for (let t of e) if (t.contains(n)) return !0;
  return !1;
}
function _o(e) {
  let n = kt(e.getSnapshot());
  return le(e.subscribe(() => {
    n.value = e.getSnapshot();
  })), n;
}
function Co(e, n) {
  let t = e(), l = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return t;
  }, subscribe(o) {
    return l.add(o), () => l.delete(o);
  }, dispatch(o, ...a) {
    let i = n[o].call(t, ...a);
    i && (t = i, l.forEach((r) => r()));
  } };
}
function Io() {
  let e;
  return { before({ doc: n }) {
    var t;
    let l = n.documentElement;
    e = ((t = n.defaultView) != null ? t : window).innerWidth - l.clientWidth;
  }, after({ doc: n, d: t }) {
    let l = n.documentElement, o = l.clientWidth - l.offsetWidth, a = e - o;
    t.style(l, "paddingRight", `${a}px`);
  } };
}
function Ro() {
  return Rt() ? { before({ doc: e, d: n, meta: t }) {
    function l(o) {
      return t.containers.flatMap((a) => a()).some((a) => a.contains(o));
    }
    n.microTask(() => {
      var o;
      if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
        let r = be();
        r.style(e.documentElement, "scrollBehavior", "auto"), n.add(() => n.microTask(() => r.dispose()));
      }
      let a = (o = window.scrollY) != null ? o : window.pageYOffset, i = null;
      n.addEventListener(e, "click", (r) => {
        if (r.target instanceof HTMLElement) try {
          let s = r.target.closest("a");
          if (!s) return;
          let { hash: u } = new URL(s.href), d = e.querySelector(u);
          d && !l(d) && (i = d);
        } catch {
        }
      }, !0), n.addEventListener(e, "touchstart", (r) => {
        if (r.target instanceof HTMLElement) if (l(r.target)) {
          let s = r.target;
          for (; s.parentElement && l(s.parentElement); ) s = s.parentElement;
          n.style(s, "overscrollBehavior", "contain");
        } else n.style(r.target, "touchAction", "none");
      }), n.addEventListener(e, "touchmove", (r) => {
        if (r.target instanceof HTMLElement) {
          if (r.target.tagName === "INPUT") return;
          if (l(r.target)) {
            let s = r.target;
            for (; s.parentElement && s.dataset.headlessuiPortal !== "" && !(s.scrollHeight > s.clientHeight || s.scrollWidth > s.clientWidth); ) s = s.parentElement;
            s.dataset.headlessuiPortal === "" && r.preventDefault();
          } else r.preventDefault();
        }
      }, { passive: !1 }), n.add(() => {
        var r;
        let s = (r = window.scrollY) != null ? r : window.pageYOffset;
        a !== s && window.scrollTo(0, a), i && i.isConnected && (i.scrollIntoView({ block: "nearest" }), i = null);
      });
    });
  } } : {};
}
function zo() {
  return { before({ doc: e, d: n }) {
    n.style(e.documentElement, "overflow", "hidden");
  } };
}
function Po(e) {
  let n = {};
  for (let t of e) Object.assign(n, t(n));
  return n;
}
let we = Co(() => /* @__PURE__ */ new Map(), { PUSH(e, n) {
  var t;
  let l = (t = this.get(e)) != null ? t : { doc: e, count: 0, d: be(), meta: /* @__PURE__ */ new Set() };
  return l.count++, l.meta.add(n), this.set(e, l), this;
}, POP(e, n) {
  let t = this.get(e);
  return t && (t.count--, t.meta.delete(n)), this;
}, SCROLL_PREVENT({ doc: e, d: n, meta: t }) {
  let l = { doc: e, d: n, meta: Po(t) }, o = [Ro(), Io(), zo()];
  o.forEach(({ before: a }) => a == null ? void 0 : a(l)), o.forEach(({ after: a }) => a == null ? void 0 : a(l));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
we.subscribe(() => {
  let e = we.getSnapshot(), n = /* @__PURE__ */ new Map();
  for (let [t] of e) n.set(t, t.documentElement.style.overflow);
  for (let t of e.values()) {
    let l = n.get(t.doc) === "hidden", o = t.count !== 0;
    (o && !l || !o && l) && we.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && we.dispatch("TEARDOWN", t);
  }
});
function Lo(e, n, t) {
  let l = _o(we), o = p(() => {
    let a = e.value ? l.value.get(e.value) : void 0;
    return a ? a.count > 0 : !1;
  });
  return ne([e, n], ([a, i], [r], s) => {
    if (!a || !i) return;
    we.dispatch("PUSH", a, t);
    let u = !1;
    s(() => {
      u || (we.dispatch("POP", r ?? a, t), u = !0);
    });
  }, { immediate: !0 }), o;
}
let Ye = /* @__PURE__ */ new Map(), Ie = /* @__PURE__ */ new Map();
function bt(e, n = k(!0)) {
  q((t) => {
    var l;
    if (!n.value) return;
    let o = E(e);
    if (!o) return;
    t(function() {
      var i;
      if (!o) return;
      let r = (i = Ie.get(o)) != null ? i : 1;
      if (r === 1 ? Ie.delete(o) : Ie.set(o, r - 1), r !== 1) return;
      let s = Ye.get(o);
      s && (s["aria-hidden"] === null ? o.removeAttribute("aria-hidden") : o.setAttribute("aria-hidden", s["aria-hidden"]), o.inert = s.inert, Ye.delete(o));
    });
    let a = (l = Ie.get(o)) != null ? l : 0;
    Ie.set(o, a + 1), a === 0 && (Ye.set(o, { "aria-hidden": o.getAttribute("aria-hidden"), inert: o.inert }), o.setAttribute("aria-hidden", "true"), o.inert = !0);
  });
}
function Do({ defaultContainers: e = [], portals: n, mainTreeNodeRef: t } = {}) {
  let l = k(null), o = xe(l);
  function a() {
    var i, r, s;
    let u = [];
    for (let d of e) d !== null && (d instanceof HTMLElement ? u.push(d) : "value" in d && d.value instanceof HTMLElement && u.push(d.value));
    if (n != null && n.value) for (let d of n.value) u.push(d);
    for (let d of (i = o == null ? void 0 : o.querySelectorAll("html > *, body > *")) != null ? i : []) d !== document.body && d !== document.head && d instanceof HTMLElement && d.id !== "headlessui-portal-root" && (d.contains(E(l)) || d.contains((s = (r = E(l)) == null ? void 0 : r.getRootNode()) == null ? void 0 : s.host) || u.some((c) => d.contains(c)) || u.push(d));
    return u;
  }
  return { resolveContainers: a, contains(i) {
    return a().some((r) => r.contains(i));
  }, mainTreeNodeRef: l, MainTreeNode() {
    return t != null ? null : N(Pe, { features: Oe.Hidden, ref: l });
  } };
}
let Zt = Symbol("ForcePortalRootContext");
function Fo() {
  return Z(Zt, !1);
}
let Je = R({ name: "ForcePortalRoot", props: { as: { type: [Object, String], default: "template" }, force: { type: Boolean, default: !1 } }, setup(e, { slots: n, attrs: t }) {
  return te(Zt, e.force), () => {
    let { force: l, ...o } = e;
    return H({ theirProps: o, ourProps: {}, slot: {}, slots: n, attrs: t, name: "ForcePortalRoot" });
  };
} }), Jt = Symbol("StackContext");
var Qe = ((e) => (e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))(Qe || {});
function Mo() {
  return Z(Jt, () => {
  });
}
function Ao({ type: e, enabled: n, element: t, onUpdate: l }) {
  let o = Mo();
  function a(...i) {
    l == null || l(...i), o(...i);
  }
  j(() => {
    ne(n, (i, r) => {
      i ? a(0, e, t) : r === !0 && a(1, e, t);
    }, { immediate: !0, flush: "sync" });
  }), le(() => {
    n.value && a(1, e, t);
  }), te(Jt, a);
}
let Qt = Symbol("DescriptionContext");
function No() {
  let e = Z(Qt, null);
  if (e === null) throw new Error("Missing parent");
  return e;
}
function en({ slot: e = k({}), name: n = "Description", props: t = {} } = {}) {
  let l = k([]);
  function o(a) {
    return l.value.push(a), () => {
      let i = l.value.indexOf(a);
      i !== -1 && l.value.splice(i, 1);
    };
  }
  return te(Qt, { register: o, slot: e, name: n, props: t }), p(() => l.value.length > 0 ? l.value.join(" ") : void 0);
}
R({ name: "Description", props: { as: { type: [Object, String], default: "p" }, id: { type: String, default: null } }, setup(e, { attrs: n, slots: t }) {
  var l;
  let o = (l = e.id) != null ? l : `headlessui-description-${re()}`, a = No();
  return j(() => le(a.register(o))), () => {
    let { name: i = "Description", slot: r = k({}), props: s = {} } = a, { ...u } = e, d = { ...Object.entries(s).reduce((c, [f, b]) => Object.assign(c, { [f]: V(b) }), {}), id: o };
    return H({ ourProps: d, theirProps: u, slot: r.value, attrs: n, slots: t, name: i });
  };
} });
function Bo(e) {
  let n = xe(e);
  if (!n) {
    if (e === null) return null;
    throw new Error(`[Headless UI]: Cannot find ownerDocument for contextElement: ${e}`);
  }
  let t = n.getElementById("headlessui-portal-root");
  if (t) return t;
  let l = n.createElement("div");
  return l.setAttribute("id", "headlessui-portal-root"), n.body.appendChild(l);
}
const et = /* @__PURE__ */ new WeakMap();
function Vo(e) {
  var n;
  return (n = et.get(e)) != null ? n : 0;
}
function yt(e, n) {
  let t = n(Vo(e));
  return t <= 0 ? et.delete(e) : et.set(e, t), t;
}
let tn = R({ name: "Portal", props: { as: { type: [Object, String], default: "div" } }, setup(e, { slots: n, attrs: t }) {
  let l = k(null), o = p(() => xe(l)), a = Fo(), i = Z(nn, null), r = k(a === !0 || i == null ? Bo(l.value) : i.resolveTarget());
  r.value && yt(r.value, (f) => f + 1);
  let s = k(!1);
  j(() => {
    s.value = !0;
  }), q(() => {
    a || i != null && (r.value = i.resolveTarget());
  });
  let u = Z(tt, null), d = !1, c = cn();
  return ne(l, () => {
    if (d || !u) return;
    let f = E(l);
    f && (le(u.register(f), c), d = !0);
  }), le(() => {
    var f, b;
    let h = (f = o.value) == null ? void 0 : f.getElementById("headlessui-portal-root");
    !h || r.value !== h || yt(r.value, (w) => w - 1) || r.value.children.length > 0 || (b = r.value.parentElement) == null || b.removeChild(r.value);
  }), () => {
    if (!s.value || r.value === null) return null;
    let f = { ref: l, "data-headlessui-portal": "" };
    return N(St, { to: r.value }, H({ ourProps: f, theirProps: e, slot: {}, attrs: t, slots: n, name: "Portal" }));
  };
} }), tt = Symbol("PortalParentContext");
function jo() {
  let e = Z(tt, null), n = k([]);
  function t(a) {
    return n.value.push(a), e && e.register(a), () => l(a);
  }
  function l(a) {
    let i = n.value.indexOf(a);
    i !== -1 && n.value.splice(i, 1), e && e.unregister(a);
  }
  let o = { register: t, unregister: l, portals: n };
  return [n, R({ name: "PortalWrapper", setup(a, { slots: i }) {
    return te(tt, o), () => {
      var r;
      return (r = i.default) == null ? void 0 : r.call(i);
    };
  } })];
}
let nn = Symbol("PortalGroupContext"), Ho = R({ name: "PortalGroup", props: { as: { type: [Object, String], default: "template" }, target: { type: Object, default: null } }, setup(e, { attrs: n, slots: t }) {
  let l = Et({ resolveTarget() {
    return e.target;
  } });
  return te(nn, l), () => {
    let { target: o, ...a } = e;
    return H({ theirProps: a, ourProps: {}, slot: {}, attrs: n, slots: t, name: "PortalGroup" });
  };
} });
var Uo = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Uo || {});
let nt = Symbol("DialogContext");
function Fe(e) {
  let n = Z(nt, null);
  if (n === null) {
    let t = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, Fe), t;
  }
  return n;
}
let Be = "DC8F892D-2EBD-447C-A4C8-A03058436FF4", Wo = R({ name: "Dialog", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, open: { type: [Boolean, String], default: Be }, initialFocus: { type: Object, default: null }, id: { type: String, default: null }, role: { type: String, default: "dialog" } }, emits: { close: (e) => !0 }, setup(e, { emit: n, attrs: t, slots: l, expose: o }) {
  var a, i;
  let r = (a = e.id) != null ? a : `headlessui-dialog-${re()}`, s = k(!1);
  j(() => {
    s.value = !0;
  });
  let u = !1, d = p(() => e.role === "dialog" || e.role === "alertdialog" ? e.role : (u || (u = !0, console.warn(`Invalid role [${d}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog")), c = k(0), f = Ue(), b = p(() => e.open === Be && f !== null ? (f.value & X.Open) === X.Open : e.open), h = k(null), w = p(() => xe(h));
  if (o({ el: h, $el: h }), !(e.open !== Be || f !== null)) throw new Error("You forgot to provide an `open` prop to the `Dialog`.");
  if (typeof b.value != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${b.value === Be ? void 0 : e.open}`);
  let C = p(() => s.value && b.value ? 0 : 1), P = p(() => C.value === 0), m = p(() => c.value > 1), I = Z(nt, null) !== null, [K, y] = jo(), { resolveContainers: z, mainTreeNodeRef: D, MainTreeNode: g } = Do({ portals: K, defaultContainers: [p(() => {
    var A;
    return (A = ae.panelRef.value) != null ? A : h.value;
  })] }), F = p(() => m.value ? "parent" : "leaf"), v = p(() => f !== null ? (f.value & X.Closing) === X.Closing : !1), x = p(() => I || v.value ? !1 : P.value), O = p(() => {
    var A, U, ie;
    return (ie = Array.from((U = (A = w.value) == null ? void 0 : A.querySelectorAll("body > *")) != null ? U : []).find((se) => se.id === "headlessui-portal-root" ? !1 : se.contains(E(D)) && se instanceof HTMLElement)) != null ? ie : null;
  });
  bt(O, x);
  let $ = p(() => m.value ? !0 : P.value), M = p(() => {
    var A, U, ie;
    return (ie = Array.from((U = (A = w.value) == null ? void 0 : A.querySelectorAll("[data-headlessui-portal]")) != null ? U : []).find((se) => se.contains(E(D)) && se instanceof HTMLElement)) != null ? ie : null;
  });
  bt(M, $), Ao({ type: "Dialog", enabled: p(() => C.value === 0), element: h, onUpdate: (A, U) => {
    if (U === "Dialog") return ee(A, { [Qe.Add]: () => c.value += 1, [Qe.Remove]: () => c.value -= 1 });
  } });
  let L = en({ name: "DialogDescription", slot: p(() => ({ open: b.value })) }), W = k(null), ae = { titleId: W, panelRef: k(null), dialogState: C, setTitleId(A) {
    W.value !== A && (W.value = A);
  }, close() {
    n("close", !1);
  } };
  te(nt, ae);
  let fe = p(() => !(!P.value || m.value));
  Lt(z, (A, U) => {
    A.preventDefault(), ae.close(), me(() => U == null ? void 0 : U.focus());
  }, fe);
  let Me = p(() => !(m.value || C.value !== 0));
  qt((i = w.value) == null ? void 0 : i.defaultView, "keydown", (A) => {
    Me.value && (A.defaultPrevented || A.key === J.Escape && (A.preventDefault(), A.stopPropagation(), ae.close()));
  });
  let ut = p(() => !(v.value || C.value !== 0 || I));
  return Lo(w, ut, (A) => {
    var U;
    return { containers: [...(U = A.containers) != null ? U : [], z] };
  }), q((A) => {
    if (C.value !== 0) return;
    let U = E(h);
    if (!U) return;
    let ie = new ResizeObserver((se) => {
      for (let Ke of se) {
        let Ae = Ke.target.getBoundingClientRect();
        Ae.x === 0 && Ae.y === 0 && Ae.width === 0 && Ae.height === 0 && ae.close();
      }
    });
    ie.observe(U), A(() => ie.disconnect());
  }), () => {
    let { open: A, initialFocus: U, ...ie } = e, se = { ...t, ref: h, id: r, role: d.value, "aria-modal": C.value === 0 ? !0 : void 0, "aria-labelledby": W.value, "aria-describedby": L.value }, Ke = { open: C.value === 0 };
    return N(Je, { force: !0 }, () => [N(tn, () => N(Ho, { target: h.value }, () => N(Je, { force: !1 }, () => N(Ce, { initialFocus: U, containers: z, features: P.value ? ee(F.value, { parent: Ce.features.RestoreFocus, leaf: Ce.features.All & ~Ce.features.FocusLock }) : Ce.features.None }, () => N(y, {}, () => H({ ourProps: se, theirProps: { ...ie, ...t }, slot: Ke, attrs: t, slots: l, visible: C.value === 0, features: ye.RenderStrategy | ye.Static, name: "Dialog" })))))), N(g)]);
  };
} });
R({ name: "DialogOverlay", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(e, { attrs: n, slots: t }) {
  var l;
  let o = (l = e.id) != null ? l : `headlessui-dialog-overlay-${re()}`, a = Fe("DialogOverlay");
  function i(r) {
    r.target === r.currentTarget && (r.preventDefault(), r.stopPropagation(), a.close());
  }
  return () => {
    let { ...r } = e;
    return H({ ourProps: { id: o, "aria-hidden": !0, onClick: i }, theirProps: r, slot: { open: a.dialogState.value === 0 }, attrs: n, slots: t, name: "DialogOverlay" });
  };
} });
R({ name: "DialogBackdrop", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { attrs: n, slots: t, expose: l }) {
  var o;
  let a = (o = e.id) != null ? o : `headlessui-dialog-backdrop-${re()}`, i = Fe("DialogBackdrop"), r = k(null);
  return l({ el: r, $el: r }), j(() => {
    if (i.panelRef.value === null) throw new Error("A <DialogBackdrop /> component is being used, but a <DialogPanel /> component is missing.");
  }), () => {
    let { ...s } = e, u = { id: a, ref: r, "aria-hidden": !0 };
    return N(Je, { force: !0 }, () => N(tn, () => H({ ourProps: u, theirProps: { ...n, ...s }, slot: { open: i.dialogState.value === 0 }, attrs: n, slots: t, name: "DialogBackdrop" })));
  };
} });
let Ko = R({ name: "DialogPanel", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(e, { attrs: n, slots: t, expose: l }) {
  var o;
  let a = (o = e.id) != null ? o : `headlessui-dialog-panel-${re()}`, i = Fe("DialogPanel");
  l({ el: i.panelRef, $el: i.panelRef });
  function r(s) {
    s.stopPropagation();
  }
  return () => {
    let { ...s } = e, u = { id: a, ref: i.panelRef, onClick: r };
    return H({ ourProps: u, theirProps: s, slot: { open: i.dialogState.value === 0 }, attrs: n, slots: t, name: "DialogPanel" });
  };
} }), qo = R({ name: "DialogTitle", props: { as: { type: [Object, String], default: "h2" }, id: { type: String, default: null } }, setup(e, { attrs: n, slots: t }) {
  var l;
  let o = (l = e.id) != null ? l : `headlessui-dialog-title-${re()}`, a = Fe("DialogTitle");
  return j(() => {
    a.setTitleId(o), le(() => a.setTitleId(null));
  }), () => {
    let { ...i } = e;
    return H({ ourProps: { id: o }, theirProps: i, slot: { open: a.dialogState.value === 0 }, attrs: n, slots: t, name: "DialogTitle" });
  };
} }), on = Symbol("LabelContext");
function ln() {
  let e = Z(on, null);
  if (e === null) {
    let n = new Error("You used a <Label /> component, but it is not inside a parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(n, ln), n;
  }
  return e;
}
function Go({ slot: e = {}, name: n = "Label", props: t = {} } = {}) {
  let l = k([]);
  function o(a) {
    return l.value.push(a), () => {
      let i = l.value.indexOf(a);
      i !== -1 && l.value.splice(i, 1);
    };
  }
  return te(on, { register: o, slot: e, name: n, props: t }), p(() => l.value.length > 0 ? l.value.join(" ") : void 0);
}
let Yo = R({ name: "Label", props: { as: { type: [Object, String], default: "label" }, passive: { type: [Boolean], default: !1 }, id: { type: String, default: null } }, setup(e, { slots: n, attrs: t }) {
  var l;
  let o = (l = e.id) != null ? l : `headlessui-label-${re()}`, a = ln();
  return j(() => le(a.register(o))), () => {
    let { name: i = "Label", slot: r = {}, props: s = {} } = a, { passive: u, ...d } = e, c = { ...Object.entries(s).reduce((f, [b, h]) => Object.assign(f, { [b]: V(h) }), {}), id: o };
    return u && (delete c.onClick, delete c.htmlFor, delete d.onClick), H({ ourProps: c, theirProps: d, slot: r, attrs: t, slots: n, name: i });
  };
} }), rn = Symbol("GroupContext"), Xo = R({ name: "SwitchGroup", props: { as: { type: [Object, String], default: "template" } }, setup(e, { slots: n, attrs: t }) {
  let l = k(null), o = Go({ name: "SwitchLabel", props: { htmlFor: p(() => {
    var i;
    return (i = l.value) == null ? void 0 : i.id;
  }), onClick(i) {
    l.value && (i.currentTarget.tagName === "LABEL" && i.preventDefault(), l.value.click(), l.value.focus({ preventScroll: !0 }));
  } } }), a = en({ name: "SwitchDescription" });
  return te(rn, { switchRef: l, labelledby: o, describedby: a }), () => H({ theirProps: e, ourProps: {}, slot: {}, slots: n, attrs: t, name: "SwitchGroup" });
} }), Zo = R({ name: "Switch", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "button" }, modelValue: { type: Boolean, default: void 0 }, defaultChecked: { type: Boolean, optional: !0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, value: { type: String, optional: !0 }, id: { type: String, default: null }, disabled: { type: Boolean, default: !1 }, tabIndex: { type: Number, default: 0 } }, inheritAttrs: !1, setup(e, { emit: n, attrs: t, slots: l, expose: o }) {
  var a;
  let i = (a = e.id) != null ? a : `headlessui-switch-${re()}`, r = Z(rn, null), [s, u] = Ot(p(() => e.modelValue), (m) => n("update:modelValue", m), p(() => e.defaultChecked));
  function d() {
    u(!s.value);
  }
  let c = k(null), f = r === null ? c : r.switchRef, b = Dt(p(() => ({ as: e.as, type: t.type })), f);
  o({ el: f, $el: f });
  function h(m) {
    m.preventDefault(), d();
  }
  function w(m) {
    m.key === J.Space ? (m.preventDefault(), d()) : m.key === J.Enter && co(m.currentTarget);
  }
  function C(m) {
    m.preventDefault();
  }
  let P = p(() => {
    var m, I;
    return (I = (m = E(f)) == null ? void 0 : m.closest) == null ? void 0 : I.call(m, "form");
  });
  return j(() => {
    ne([P], () => {
      if (!P.value || e.defaultChecked === void 0) return;
      function m() {
        u(e.defaultChecked);
      }
      return P.value.addEventListener("reset", m), () => {
        var I;
        (I = P.value) == null || I.removeEventListener("reset", m);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: m, value: I, form: K, tabIndex: y, ...z } = e, D = { checked: s.value }, g = { id: i, ref: f, role: "switch", type: b.value, tabIndex: y === -1 ? 0 : y, "aria-checked": s.value, "aria-labelledby": r == null ? void 0 : r.labelledby.value, "aria-describedby": r == null ? void 0 : r.describedby.value, onClick: h, onKeyup: w, onKeypress: C };
    return N(ue, [m != null && s.value != null ? N(Pe, At({ features: Oe.Hidden, as: "input", type: "checkbox", hidden: !0, readOnly: !0, checked: s.value, form: K, disabled: z.disabled, name: m, value: I })) : null, H({ ourProps: g, theirProps: { ...t, ..._e(z, ["modelValue", "defaultChecked"]) }, slot: D, attrs: t, slots: l, name: "Switch" })]);
  };
} }), Jo = Yo;
function Qo(e) {
  let n = { called: !1 };
  return (...t) => {
    if (!n.called) return n.called = !0, e(...t);
  };
}
function Xe(e, ...n) {
  e && n.length > 0 && e.classList.add(...n);
}
function Ve(e, ...n) {
  e && n.length > 0 && e.classList.remove(...n);
}
var ot = ((e) => (e.Finished = "finished", e.Cancelled = "cancelled", e))(ot || {});
function el(e, n) {
  let t = be();
  if (!e) return t.dispose;
  let { transitionDuration: l, transitionDelay: o } = getComputedStyle(e), [a, i] = [l, o].map((r) => {
    let [s = 0] = r.split(",").filter(Boolean).map((u) => u.includes("ms") ? parseFloat(u) : parseFloat(u) * 1e3).sort((u, d) => d - u);
    return s;
  });
  return a !== 0 ? t.setTimeout(() => n("finished"), a + i) : n("finished"), t.add(() => n("cancelled")), t.dispose;
}
function xt(e, n, t, l, o, a) {
  let i = be(), r = a !== void 0 ? Qo(a) : () => {
  };
  return Ve(e, ...o), Xe(e, ...n, ...t), i.nextFrame(() => {
    Ve(e, ...t), Xe(e, ...l), i.add(el(e, (s) => (Ve(e, ...l, ...n), Xe(e, ...o), r(s))));
  }), i.add(() => Ve(e, ...n, ...t, ...l, ...o)), i.add(() => r("cancelled")), i.dispose;
}
function ke(e = "") {
  return e.split(/\s+/).filter((n) => n.length > 1);
}
let it = Symbol("TransitionContext");
var tl = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))(tl || {});
function nl() {
  return Z(it, null) !== null;
}
function ol() {
  let e = Z(it, null);
  if (e === null) throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
function ll() {
  let e = Z(st, null);
  if (e === null) throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
let st = Symbol("NestingContext");
function We(e) {
  return "children" in e ? We(e.children) : e.value.filter(({ state: n }) => n === "visible").length > 0;
}
function an(e) {
  let n = k([]), t = k(!1);
  j(() => t.value = !0), le(() => t.value = !1);
  function l(a, i = he.Hidden) {
    let r = n.value.findIndex(({ id: s }) => s === a);
    r !== -1 && (ee(i, { [he.Unmount]() {
      n.value.splice(r, 1);
    }, [he.Hidden]() {
      n.value[r].state = "hidden";
    } }), !We(n) && t.value && (e == null || e()));
  }
  function o(a) {
    let i = n.value.find(({ id: r }) => r === a);
    return i ? i.state !== "visible" && (i.state = "visible") : n.value.push({ id: a, state: "visible" }), () => l(a, he.Unmount);
  }
  return { children: n, register: o, unregister: l };
}
let sn = ye.RenderStrategy, lt = R({ props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: n, attrs: t, slots: l, expose: o }) {
  let a = k(0);
  function i() {
    a.value |= X.Opening, n("beforeEnter");
  }
  function r() {
    a.value &= ~X.Opening, n("afterEnter");
  }
  function s() {
    a.value |= X.Closing, n("beforeLeave");
  }
  function u() {
    a.value &= ~X.Closing, n("afterLeave");
  }
  if (!nl() && io()) return () => N(un, { ...e, onBeforeEnter: i, onAfterEnter: r, onBeforeLeave: s, onAfterLeave: u }, l);
  let d = k(null), c = p(() => e.unmount ? he.Unmount : he.Hidden);
  o({ el: d, $el: d });
  let { show: f, appear: b } = ol(), { register: h, unregister: w } = ll(), C = k(f.value ? "visible" : "hidden"), P = { value: !0 }, m = re(), I = { value: !1 }, K = an(() => {
    !I.value && C.value !== "hidden" && (C.value = "hidden", w(m), u());
  });
  j(() => {
    let $ = h(m);
    le($);
  }), q(() => {
    if (c.value === he.Hidden && m) {
      if (f.value && C.value !== "visible") {
        C.value = "visible";
        return;
      }
      ee(C.value, { hidden: () => w(m), visible: () => h(m) });
    }
  });
  let y = ke(e.enter), z = ke(e.enterFrom), D = ke(e.enterTo), g = ke(e.entered), F = ke(e.leave), v = ke(e.leaveFrom), x = ke(e.leaveTo);
  j(() => {
    q(() => {
      if (C.value === "visible") {
        let $ = E(d);
        if ($ instanceof Comment && $.data === "") throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
      }
    });
  });
  function O($) {
    let M = P.value && !b.value, L = E(d);
    !L || !(L instanceof HTMLElement) || M || (I.value = !0, f.value && i(), f.value || s(), $(f.value ? xt(L, y, z, D, g, (W) => {
      I.value = !1, W === ot.Finished && r();
    }) : xt(L, F, v, x, g, (W) => {
      I.value = !1, W === ot.Finished && (We(K) || (C.value = "hidden", w(m), u()));
    })));
  }
  return j(() => {
    ne([f], ($, M, L) => {
      O(L), P.value = !1;
    }, { immediate: !0 });
  }), te(st, K), Bt(p(() => ee(C.value, { visible: X.Open, hidden: X.Closed }) | a.value)), () => {
    let { appear: $, show: M, enter: L, enterFrom: W, enterTo: ae, entered: fe, leave: Me, leaveFrom: ut, leaveTo: A, ...U } = e, ie = { ref: d }, se = { ...U, ...b.value && f.value && De.isServer ? { class: de([t.class, U.class, ...y, ...z]) } : {} };
    return H({ theirProps: se, ourProps: ie, slot: {}, slots: l, attrs: t, features: sn, visible: C.value === "visible", name: "TransitionChild" });
  };
} }), rl = lt, un = R({ inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: n, attrs: t, slots: l }) {
  let o = Ue(), a = p(() => e.show === null && o !== null ? (o.value & X.Open) === X.Open : e.show);
  q(() => {
    if (![!0, !1].includes(a.value)) throw new Error('A <Transition /> is used but it is missing a `:show="true | false"` prop.');
  });
  let i = k(a.value ? "visible" : "hidden"), r = an(() => {
    i.value = "hidden";
  }), s = k(!0), u = { show: a, appear: p(() => e.appear || !s.value) };
  return j(() => {
    q(() => {
      s.value = !1, a.value ? i.value = "visible" : We(r) || (i.value = "hidden");
    });
  }), te(st, r), te(it, u), () => {
    let d = _e(e, ["show", "appear", "unmount", "onBeforeEnter", "onBeforeLeave", "onAfterEnter", "onAfterLeave"]), c = { unmount: e.unmount };
    return H({ ourProps: { ...c, as: "template" }, theirProps: {}, slot: {}, slots: { ...l, default: () => [N(rl, { onBeforeEnter: () => n("beforeEnter"), onAfterEnter: () => n("afterEnter"), onBeforeLeave: () => n("beforeLeave"), onAfterLeave: () => n("afterLeave"), ...t, ...c, ...d }, l.default)] }, attrs: {}, features: sn, visible: i.value === "visible", name: "Transition" });
  };
} });
const al = /* @__PURE__ */ R({
  __name: "TESwitch",
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e) {
    return (n, t) => (S(), Se(V(Zo), {
      "model-value": n.modelValue,
      class: de(["relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:dark:ring-primary-800 focus:ring-offset-2 focus:ring-primary-600", [
        n.modelValue ? "bg-primary-600 dark:bg-primary-800" : "bg-gray-200 dark:bg-zinc-400 "
      ]]),
      "onUpdate:modelValue": t[0] || (t[0] = (l) => n.$emit("update:modelValue", l))
    }, {
      default: Q(() => [
        t[1] || (t[1] = T("span", { class: "sr-only" }, null, -1)),
        T("span", {
          "aria-hidden": "true",
          class: de(["pointer-events-none inline-block size-5 transform rounded-full dark:bg-zinc-800 bg-white shadow ring-0 transition duration-200 ease-in-out", [n.modelValue ? "translate-x-5" : "translate-x-0"]])
        }, null, 2)
      ]),
      _: 1
    }, 8, ["model-value", "class"]));
  }
}), il = { class: "font-medium text-gray-900 dark:text-zinc-50" }, sl = {
  key: 0,
  class: "text-gray-500 dark:text-zinc-200"
}, ul = /* @__PURE__ */ R({
  __name: "TESwitchLabel",
  props: {
    title: {},
    subtitle: {}
  },
  setup(e) {
    return (n, t) => (S(), Se(V(Xo), {
      as: "div",
      class: "flex items-center"
    }, {
      default: Q(() => [
        B(n.$slots, "default"),
        oe(V(Jo), {
          as: "span",
          class: "ml-3 text-sm flex flex-col items-start"
        }, {
          default: Q(() => [
            T("div", il, ce(n.title), 1),
            n.subtitle ? (S(), _("div", sl, ce(n.subtitle), 1)) : Y("", !0)
          ]),
          _: 1
        })
      ]),
      _: 3
    }));
  }
}), dl = /* @__PURE__ */ R({
  __name: "TEBadge",
  props: {
    type: {}
  },
  setup(e) {
    const n = e, t = {
      white: "bg-zinc-200/40 text-zinc-800 border-zinc-300 dark:border-zinc-700 dark:bg-zinc-700/50 dark:text-zinc-200",
      accent: "bg-accent-200/40 text-accent-800 border-accent-300 dark:border-accent-700 dark:bg-accent-700/50 dark:text-accent-200",
      red: "bg-red-200/40 text-red-800 border-red-300 dark:border-red-700 dark:bg-red-900/50 dark:border-red-900 dark:text-red-500",
      orange: "bg-orange-200/40 text-orange-800 border-orange-300 dark:border-orange-700 dark:bg-orange-900/50 dark:text-orange-500",
      yellow: "bg-yellow-200/40 text-yellow-800 border-yellow-300 dark:border-yellow-700 dark:bg-yellow-900/50 dark:text-yellow-500",
      green: "bg-green-200/40 text-green-800 border-green-300 dark:border-green-700 dark:bg-green-900/50 dark:text-green-500",
      teal: "bg-teal-200/40 text-teal-800 border-teal-300 dark:border-teal-700 dark:bg-teal-900/50 dark:text-teal-500",
      blue: "bg-blue-200/40 text-blue-800 border-blue-300 dark:border-blue-700 dark:bg-blue-900/50 dark:text-blue-500",
      sky: "bg-sky-200/40 text-sky-800 border-sky-300 dark:border-sky-700 dark:bg-sky-900/50 dark:text-sky-500",
      indigo: "bg-indigo-200/40 text-indigo-800 border-indigo-300 dark:border-indigo-700 dark:bg-indigo-900/60 dark:text-indigo-400",
      purple: "bg-purple-200/40 text-purple-800 border-purple-300 dark:border-purple-700 dark:bg-purple-900/60 dark:text-purple-400",
      pink: "bg-pink-200/40 text-pink-800 border-pink-300 dark:border-pink-700 dark:bg-pink-900/50 dark:text-pink-500",
      primary: "bg-primary-200/40 text-primary-800 border-primary-300 dark:border-primary-700 dark:bg-primary-900/50 dark:text-primary-500",
      rose: "bg-rose-200/40 text-rose-800 border-rose-300 dark:border-rose-700 dark:bg-rose-900/50 dark:text-rose-500",
      emerald: "bg-emerald-200/40 text-emerald-800 border-emerald-300 dark:border-emerald-700 dark:bg-emerald-900/50 dark:text-emerald-500"
    }, l = p(() => t[n.type ?? "primary"]);
    return (o, a) => (S(), _("span", {
      class: de([l.value, "rounded-full p-1 px-2"])
    }, [
      B(o.$slots, "default")
    ], 2));
  }
}), cl = { class: "fixed inset-0 z-10 overflow-y-auto" }, pl = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }, fl = { class: "bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 dark:bg-zinc-800" }, vl = { class: "sm:flex sm:items-start" }, ml = { class: "mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left" }, gl = { class: "mt-2" }, hl = { class: "text-sm text-gray-500 dark:text-zinc-200" }, bl = { class: "bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 dark:bg-zinc-700" }, yl = /* @__PURE__ */ R({
  __name: "TEModal",
  props: {
    open: { type: Boolean }
  },
  emits: ["update:open"],
  setup(e) {
    return (n, t) => (S(), Se(V(un), {
      as: "template",
      show: n.open
    }, {
      default: Q(() => [
        oe(V(Wo), {
          as: "div",
          class: "relative z-10",
          onClose: t[0] || (t[0] = (l) => n.$emit("update:open", !1))
        }, {
          default: Q(() => [
            oe(V(lt), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: Q(() => t[1] || (t[1] = [
                T("div", { class: "fixed inset-0 bg-gray-500/75 transition-opacity" }, null, -1)
              ])),
              _: 1
            }),
            T("div", cl, [
              T("div", pl, [
                oe(V(lt), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: Q(() => [
                    oe(V(Ko), { class: "relative overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg dark:bg-zinc-800" }, {
                      default: Q(() => [
                        T("div", fl, [
                          T("div", vl, [
                            T("div", ml, [
                              oe(V(qo), {
                                as: "h3",
                                class: "text-base font-semibold leading-6 text-gray-900 dark:text-zinc-50"
                              }, {
                                default: Q(() => [
                                  B(n.$slots, "title")
                                ]),
                                _: 3
                              }),
                              T("div", gl, [
                                T("p", hl, [
                                  B(n.$slots, "default")
                                ])
                              ])
                            ])
                          ])
                        ]),
                        T("div", bl, [
                          B(n.$slots, "actions")
                        ])
                      ]),
                      _: 3
                    })
                  ]),
                  _: 3
                })
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), xl = {}, kl = {
  "aria-label": "assertive",
  class: "pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
};
function wl(e, n) {
  return S(), _("div", kl, n[0] || (n[0] = [
    T("div", {
      id: "te-notifications",
      class: "flex w-full flex-col items-center space-y-4 sm:items-end"
    }, null, -1)
  ]));
}
const El = /* @__PURE__ */ Le(xl, [["render", wl]]), Sl = {
  key: 0,
  class: "dark:bg-zinc-800 pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/5 dark:ring-zinc-700"
}, Tl = { class: "p-4" }, $l = { class: "flex items-start" }, Ol = {
  key: 0,
  class: "mr-3 shrink-0"
}, _l = { class: "w-0 flex-1" }, Cl = { class: "text-sm font-medium text-zinc-900 dark:text-white" }, Il = {
  key: 0,
  class: "mt-1 text-sm text-zinc-500 dark:text-zinc-100"
}, Rl = {
  key: 1,
  class: "mt-3 flex space-x-7"
}, zl = {
  key: 1,
  class: "ml-4 flex shrink-0"
}, rt = /* @__PURE__ */ R({
  __name: "TENotification",
  props: {
    show: { type: Boolean },
    closeable: { type: Boolean },
    title: {},
    description: {},
    autoClose: { type: Boolean },
    color: {}
  },
  emits: ["update:show"],
  setup(e, { emit: n }) {
    const t = e, l = n, o = k(!1);
    let a;
    return j(() => {
      o.value = !0, pn(() => {
        clearTimeout(a);
      });
    }), setTimeout(() => {
      l("update:show", !1);
    }, 2500), q(() => {
      t.autoClose && t.show ? typeof window < "u" && (a = window.setTimeout(() => {
        l("update:show", !1);
      }, 2500)) : a && clearTimeout(a);
    }), (i, r) => o.value ? (S(), Se(St, {
      key: 0,
      to: "#te-notifications"
    }, [
      oe(Tt, {
        "enter-active-class": "transition duration-300 ease-out transform",
        "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
        "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
        "leave-active-class": "transition duration-100 ease-in",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }),
      i.show ? (S(), _("div", Sl, [
        i.autoClose ? (S(), _("div", {
          key: 0,
          class: de(["te-notification-progress h-1", {
            "bg-green-500": i.color === "green",
            "bg-red-500": i.color === "red",
            "bg-primary-500": !i.color
          }]),
          style: { "animation-duration": "2500ms" }
        }, null, 2)) : Y("", !0),
        T("div", Tl, [
          T("div", $l, [
            i.$slots.icon ? (S(), _("div", Ol, [
              B(i.$slots, "icon")
            ])) : Y("", !0),
            T("div", _l, [
              T("p", Cl, ce(i.title), 1),
              i.description || i.$slots.default ? (S(), _("p", Il, [
                B(i.$slots, "default", {}, () => [
                  He(ce(i.description), 1)
                ])
              ])) : Y("", !0),
              i.$slots.actions ? (S(), _("div", Rl, [
                B(i.$slots, "actions")
              ])) : Y("", !0)
            ]),
            i.closeable ? (S(), _("div", zl, [
              T("button", {
                class: "size-4",
                type: "submit",
                onClick: r[0] || (r[0] = (s) => i.$emit("update:show", !1))
              }, r[1] || (r[1] = [
                T("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.5",
                  class: "dark:text-white size-6",
                  stroke: "currentColor"
                }, [
                  T("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M6 18 18 6M6 6l12 12"
                  })
                ], -1)
              ]))
            ])) : Y("", !0)
          ])
        ])
      ])) : Y("", !0)
    ])) : Y("", !0);
  }
}), Pl = R({
  name: "TEFlashNotification",
  components: { TENotification: rt },
  props: {
    show: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      default: void 0
    },
    autoClose: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:show"],
  // eslint-disable-next-line vue/component-api-style
  render() {
    return N(rt, {
      show: this.show,
      "onUpdate:show": (e) => this.$emit("update:show", e),
      title: this.title,
      description: this.description,
      autoClose: !0
    });
  }
}), Ll = {}, Dl = { class: "max-w-8xl bg-white w-full rounded-md shadow-xl dark:bg-zinc-800" }, Fl = { class: "p-4 dark:border-zinc-700 border-b-2" }, Ml = { class: "text-2xl font-medium dark:text-gray-50" }, Al = {
  key: 0,
  class: "text-sm text-gray-500 dark:text-gray-300"
};
function Nl(e, n) {
  return S(), _("div", Dl, [
    T("div", Fl, [
      T("h2", Ml, [
        B(e.$slots, "title")
      ]),
      e.$slots.subtitle ? (S(), _("p", Al, [
        B(e.$slots, "subtitle")
      ])) : Y("", !0)
    ]),
    T("div", null, [
      B(e.$slots, "default")
    ])
  ]);
}
const Bl = /* @__PURE__ */ Le(Ll, [["render", Nl]]), Vl = {}, jl = { class: "md:grid md:grid-cols-2 hover:bg-gray-50 md:space-y-0 space-y-1 p-4 border-b dark:border-zinc-700 dark:hover:bg-zinc-700" }, Hl = { class: "text-gray-600 dark:text-gray-200" }, Ul = { class: "dark:text-white" };
function Wl(e, n) {
  return S(), _("div", jl, [
    T("p", Hl, [
      B(e.$slots, "name")
    ]),
    T("p", Ul, [
      B(e.$slots, "default")
    ])
  ]);
}
const Kl = /* @__PURE__ */ Le(Vl, [["render", Wl]]);
function ql(e, n) {
  return S(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    T("path", {
      "fill-rule": "evenodd",
      d: "M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Gl(e, n) {
  return S(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    T("path", {
      "fill-rule": "evenodd",
      d: "M10.53 3.47a.75.75 0 0 0-1.06 0L6.22 6.72a.75.75 0 0 0 1.06 1.06L10 5.06l2.72 2.72a.75.75 0 1 0 1.06-1.06l-3.25-3.25Zm-4.31 9.81 3.25 3.25a.75.75 0 0 0 1.06 0l3.25-3.25a.75.75 0 1 0-1.06-1.06L10 14.94l-2.72-2.72a.75.75 0 0 0-1.06 1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const Yl = { class: "relative" }, Xl = {
  key: 0,
  class: "text-sm text-red-600"
}, Zl = /* @__PURE__ */ R({
  __name: "TESelect",
  props: {
    options: {},
    valueKey: {},
    displayKey: {},
    modelValue: {},
    multiple: { type: Boolean },
    label: {},
    error: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, l = n, o = k(t.modelValue);
    ne(
      () => o.value,
      (r) => {
        l("update:modelValue", r);
      },
      { immediate: !0 }
    );
    const a = k(""), i = p(
      () => a.value === "" ? t.options : t.options.filter(
        (r) => r[t.displayKey].toLowerCase().replaceAll(/\s+/g, "").includes(a.value.toLowerCase().replaceAll(/\s+/g, ""))
      )
    );
    return (r, s) => (S(), _(ue, null, [
      oe(V(ho), {
        modelValue: o.value,
        "onUpdate:modelValue": s[1] || (s[1] = (u) => o.value = u),
        multiple: t.multiple ?? !1,
        as: "div",
        name: "nameprop"
      }, {
        default: Q(() => [
          oe(V(bo), { class: "block text-sm font-medium leading-6 text-zinc-900 dark:text-zinc-300" }, {
            default: Q(() => [
              He(ce(r.label), 1)
            ]),
            _: 1
          }),
          T("div", Yl, [
            oe(V(xo), {
              class: "block w-full rounded-md bg-white dark:text-white dark:bg-zinc-600 py-1.5 pl-3 pr-12 text-base text-zinc-900 outline outline-1 -outline-offset-1 outline-zinc-300 dark:outline-zinc-900 placeholder:text-zinc-400 focus:outline focus:outline-2 focus:-outline-offset-2 dark:focus:outline-primary-900 focus:outline-primary-600 sm:text-sm/6",
              "display-value": (u) => Array.isArray(u) ? u.map((d) => d[r.displayKey]).join(", ") : u[r.displayKey],
              onChange: s[0] || (s[0] = (u) => a.value = u.target.value)
            }, null, 8, ["display-value"]),
            oe(V(yo), { class: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none" }, {
              default: Q(() => [
                oe(V(Gl), {
                  class: "size-5 text-zinc-400",
                  "aria-hidden": "true"
                })
              ]),
              _: 1
            }),
            oe(Tt, {
              "enter-active-class": "transition duration-100 ease-out",
              "enter-from-class": "transform scale-95 opacity-0",
              "enter-to-class": "transform scale-100 opacity-100",
              "leave-active-class": "transition duration-75 ease-out",
              "leave-from-class": "transform scale-100 opacity-100",
              "leave-to-class": "transform scale-95 opacity-0"
            }, {
              default: Q(() => [
                i.value.length > 0 ? (S(), Se(V(ko), {
                  key: 0,
                  class: "absolute z-10 mt-1 max-h-60 w-full overflow-auto dark:ring-zinc-900 focus:dark:ring-primary-900 rounded-md bg-white dark:bg-zinc-600 py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm"
                }, {
                  default: Q(() => [
                    (S(!0), _(ue, null, ze(i.value, (u) => (S(), Se(V(wo), {
                      key: u[r.valueKey],
                      value: u,
                      as: "template"
                    }, {
                      default: Q(({ active: d, selected: c }) => [
                        T("li", {
                          class: de(["relative cursor-default select-none py-2 pl-3 pr-9", [
                            d ? "bg-primary-600 text-white outline-none" : "text-zinc-900 dark:text-zinc-200"
                          ]])
                        }, [
                          T("span", {
                            class: de(["block truncate", [c && "font-semibold"]])
                          }, ce(u[r.displayKey]), 3),
                          c ? (S(), _("span", {
                            key: 0,
                            class: de(["absolute inset-y-0 right-0 flex items-center pr-4", [d ? "text-white" : "text-primary-600"]])
                          }, [
                            oe(V(ql), {
                              class: "size-5",
                              "aria-hidden": "true"
                            })
                          ], 2)) : Y("", !0)
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["value"]))), 128))
                  ]),
                  _: 1
                })) : Y("", !0)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "multiple"]),
      r.error ? (S(), _("div", Xl, ce(r.error), 1)) : Y("", !0)
    ], 64));
  }
}), Jl = {}, Ql = { class: "text-base font-semibold leading-7 text-gray-900 dark:text-gray-50" }, er = { class: "mt-1 text-sm leading-6 text-gray-600 dark:text-gray-300" };
function tr(e, n) {
  return S(), _(ue, null, [
    T("h2", Ql, [
      B(e.$slots, "header")
    ]),
    T("p", er, [
      B(e.$slots, "default")
    ])
  ], 64);
}
const nr = /* @__PURE__ */ Le(Jl, [["render", tr]]), or = { class: "flex items-center justify-between py-3" }, lr = { class: "flex flex-1 justify-between sm:hidden" }, rr = ["href"], ar = ["href"], ir = { class: "hidden sm:block" }, sr = {
  class: "isolate inline-flex -space-x-px rounded-md shadow-sm",
  "aria-label": "Pagination"
}, ur = ["href", "innerHTML"], dr = "first:rounded-l-md last:rounded-r-md relative z-10 inline-flex items-center dark:bg-primary-800 bg-primary-600 px-4 py-2 text-sm font-semibold text-white focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600", cr = "first:rounded-l-md last:rounded-r-md relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 dark:bg-zinc-800 dark:text-white dark:ring-primary-600 dark:hover:bg-primary-600 dark:focus:bg-primary-600 dark:focus:ring-primary-600 dark:focus:ring-offset-gray-700 dark:focus:outline-primary-600", pr = /* @__PURE__ */ R({
  __name: "TEPagination",
  props: {
    pagination: {}
  },
  setup(e) {
    return (n, t) => (S(), _("div", or, [
      T("div", lr, [
        T("a", {
          href: n.pagination.links[0].url ?? void 0,
          class: "bg-primary-500 dark:bg-primary-800 hover:bg-primary-600 focus:bg-primary-600 hover:bg-primary-600 focus:bg-primary-600 active:bg-primary-700 hover:dark:bg-primary-700 inline-block rounded-full px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out focus:outline-none focus:ring-0"
        }, "Vorherige Seite", 8, rr),
        T("a", {
          href: n.pagination.links[n.pagination.links.length - 1].url ?? "#",
          class: "bg-primary-500 dark:bg-primary-800 hover:bg-primary-600 focus:bg-primary-600 hover:bg-primary-600 focus:bg-primary-600 active:bg-primary-700 hover:dark:bg-primary-700 inline-block rounded-full px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out focus:outline-none focus:ring-0"
        }, "Nächste", 8, ar)
      ]),
      T("div", ir, [
        T("nav", sr, [
          (S(!0), _(ue, null, ze(n.pagination.links, (l) => (S(), _("a", {
            key: l.label,
            href: l.url ?? void 0,
            class: de(["whitespace-nowrap", l.active ? dr : cr]),
            innerHTML: l.label
          }, null, 10, ur))), 128))
        ])
      ])
    ]));
  }
}), fr = { class: "overflow-x-auto sm:-mx-6 lg:-mx-8" }, vr = { class: "inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8" }, mr = { class: "overflow-hidden shadow ring-1 ring-black/5 sm:rounded-lg" }, gr = { class: "min-w-full divide-y divide-gray-300 dark:divide-gray-800" }, hr = { class: "border-b border-neutral-200 dark:border-neutral-700 bg-zinc-50 dark:bg-zinc-800 dark:text-zinc-50 text-gray-900 text-left text-sm font-semibold" }, br = {
  key: 0,
  scope: "col",
  class: "p-3 w-24 text-right"
}, yr = { class: "divide-y divide-gray-200 dark:divide-zinc-700 bg-white dark:text-zinc-100 dark:bg-zinc-900" }, xr = {
  key: 0,
  class: "relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6"
}, kr = /* @__PURE__ */ R({
  __name: "TETable",
  props: {
    data: {},
    headers: {}
  },
  setup(e) {
    return (n, t) => (S(), _("div", fr, [
      T("div", vr, [
        T("div", mr, [
          T("table", gr, [
            T("thead", hr, [
              T("tr", null, [
                (S(!0), _(ue, null, ze(n.headers, (l) => (S(), _("th", {
                  key: l.key,
                  scope: "col",
                  class: de(["p-3", `${l.bold ? "font-bold" : void 0}`])
                }, ce(l.name), 3))), 128)),
                n.$slots.action ? (S(), _("th", br, " Aktionen ")) : Y("", !0)
              ])
            ]),
            T("tbody", yr, [
              (S(!0), _(ue, null, ze(n.data, (l, o) => (S(), _("tr", { key: o }, [
                (S(!0), _(ue, null, ze(n.headers, (a) => {
                  var i;
                  return S(), _("td", {
                    key: a.key,
                    class: "whitespace-nowrap px-3 py-4 text-sm"
                  }, [
                    ((i = n.$slots) == null ? void 0 : i[a.key]) ?? !1 ? B(n.$slots, a.key, {
                      key: 0,
                      rowData: l
                    }) : (S(), _(ue, { key: 1 }, [
                      He(ce(l[a.key]), 1)
                    ], 64))
                  ]);
                }), 128)),
                n.$slots.action ? (S(), _("td", xr, [
                  B(n.$slots, "action", { rowData: l })
                ])) : Y("", !0)
              ]))), 128))
            ])
          ])
        ])
      ])
    ]));
  }
}), wr = ["type"], Er = ["href"], Sr = /* @__PURE__ */ R({
  __name: "TETextButton",
  props: {
    tag: {},
    href: {},
    method: {},
    type: {}
  },
  setup(e) {
    const n = e;
    return (t, l) => n.tag === "button" ? (S(), _("button", {
      key: 0,
      type: n.type,
      class: "font-semibold inline-block text-primary-600 hover:text-primary-500"
    }, [
      B(t.$slots, "default")
    ], 8, wr)) : n.tag === "a" ? (S(), _("a", {
      key: 1,
      href: n.href,
      class: "font-semibold inline-block text-primary-600 hover:text-primary-500"
    }, [
      B(t.$slots, "default")
    ], 8, Er)) : (S(), Se(fn("InertiaLink"), {
      key: 2,
      href: n.href,
      method: n.method ?? "get",
      class: "font-semibold inline-block text-primary-600 hover:text-primary-500"
    }, {
      default: Q(() => [
        B(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["href", "method"]));
  }
}), Or = {
  install: (e) => {
    e.component("TEButton", mn), e.component("TETable", kr), e.component("TEBadge", dl), e.component("TESwitch", al), e.component("TESwitchLabel", ul), e.component("TEModal", yl), e.component("TETextButton", Sr), e.component("TETopLabelLayout", In), e.component("TECard", wn), e.component("TETextInput", Sn), e.component("TENotificationHost", El), e.component("TENotification", rt), e.component("TEFlashNotification", Pl), e.component("TEDescriptionList", Bl), e.component("TEDescriptionListItem", Kl), e.component("TESelect", Zl), e.component("TEFormSectionHeader", nr), e.component("TEPagination", pr);
  }
};
export {
  dl as TEBadge,
  mn as TEButton,
  wn as TECard,
  Bl as TEDescriptionList,
  Kl as TEDescriptionListItem,
  Pl as TEFlashNotification,
  nr as TEFormSectionHeader,
  yl as TEModal,
  rt as TENotification,
  El as TENotificationHost,
  pr as TEPagination,
  Zl as TESelect,
  al as TESwitch,
  ul as TESwitchLabel,
  kr as TETable,
  Sr as TETextButton,
  Sn as TETextInput,
  In as TETopLabelLayout,
  Or as default
};
